import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Umroh() {
  const navigate = useNavigate();
  // 01 Juli 2025
  const [showJsbThaifDetail, setShowJsbThaifDetail] = useState(false); //Juli Super Berkah
  const [showOrderJsbQuad1JuliForm, setShowOrderJsbQuad1JuliForm] =
    useState(false);
  const [showOrderJsbTriple1JuliForm, setShowOrderJsbTriple1JuliForm] =
    useState(false);
  const [showOrderJsbDouble1JuliForm, setShowOrderJsbDouble1JuliForm] =
    useState(false);

  // 31 Juli 2025
  const [showJmsmDetail, setShowJmsmDetail] = useState(false); //Juli Mumtaaz Spesial Muharram
  const [showJbsmDetail, setShowJbsmDetail] = useState(false); //Juli Berkah Spesial Muharram
  const [showOrderJbsmQuad31JuliForm, setShowOrderJbsmQuad31JuliForm] =
    useState(false);
  const [showOrderJbsmTriple31JuliForm, setShowOrderJbsmTriple31JuliForm] =
    useState(false);
  const [showOrderJbsmDouble31JuliForm, setShowOrderJbsmDouble31JuliForm] =
    useState(false);
  const [showOrderJmsmQuad31JuliForm, setShowOrderJmsmQuad31JuliForm] =
    useState(false);
  const [showOrderJmsmTriple31JuliForm, setShowOrderJmsmTriple31JuliForm] =
    useState(false);
  const [showOrderJmsmDouble31JuliForm, setShowOrderJmsmDouble31JuliForm] =
    useState(false);

  // 08 Agustus 2025
  const [showAmtfsDetail, setShowAmtfsDetail] = useState(false); //Agustus Mumtaaz Family Series
  const [showAmbfsDetail, setShowAmbfsDetail] = useState(false); //Agustus Mahabbah Family Series
  const [showOrderAmtfsQuad8AgustusForm, setShowOrderAmtfsQuad8AgustusForm] =
    useState(false);
  const [
    showOrderAmtfsTriple8AgustusForm,
    setShowOrderAmtfsTriple8AgustusForm,
  ] = useState(false);
  const [
    showOrderAmtfsDouble8AgustusForm,
    setShowOrderAmtfsDouble8AgustusForm,
  ] = useState(false);
  const [showOrderAmbfsQuad8AgustusForm, setShowOrderAmbfsQuad8AgustusForm] =
    useState(false);
  const [
    showOrderAmbfsTriple8AgustusForm,
    setShowOrderAmbfsTriple8AgustusForm,
  ] = useState(false);
  const [
    showOrderAmbfsDouble8AgustusForm,
    setShowOrderAmbfsDouble8AgustusForm,
  ] = useState(false);

  // 18 Agustus 2025
  const [showAsbthaifsmDetail, setShowAsbthaifsmDetail] = useState(false); // Agustus Syabab Berkah thaif spesial muda-mudi
  const [showAsmthaifsmDetail, setShowAsmthaifsmDetail] = useState(false); // Agustus Syabab Mahabbah thaif spesial muda-mudi
  const [
    showOrderAsbthaifQuad18AgustusForm,
    setShowOrderAsbthaifQuad18AgustusForm,
  ] = useState(false);
  const [
    showOrderAsbthaifTriple18AgustusForm,
    setShowOrderAsbthaifTriple18AgustusForm,
  ] = useState(false);
  const [
    showOrderAsbthaifDouble18AgustusForm,
    setShowOrderAsbthaifDouble18AgustusForm,
  ] = useState(false);
  const [
    showOrderAsmthaifQuad18AgustusForm,
    setShowOrderAsmthaifQuad18AgustusForm,
  ] = useState(false);
  const [
    showOrderAsmthaifTriple18AgustusForm,
    setShowOrderAsmthaifTriple18AgustusForm,
  ] = useState(false);
  const [
    showOrderAsmthaifDouble18AgustusForm,
    setShowOrderAsmthaifDouble18AgustusForm,
  ] = useState(false);

  // 27 Agustus 2025
  const [showAbDetail, setShowAbDetail] = useState(false);
  const [showOrderAbQuad27AgustusForm, setShowOrderAbQuad27AgustusForm] =
    useState(false);
  const [showOrderAbTriple27AgustusForm, setShowOrderAbTriple27AgustusForm] =
    useState(false);
  const [showOrderAbDouble27AgustusForm, setShowOrderAbDouble27AgustusForm] =
    useState(false);

  // 3 September 2025
  const [showSbDetail, setShowSbDetail] = useState(false); // September Berkah 2x Jum'at
  const [showOrderSbQuad3SeptemberForm, setShowOrderSbQuad3SeptemberForm] =
    useState(false);
  const [showOrderSbTriple3SeptemberForm, setShowOrderSbTriple3SeptemberForm] =
    useState(false);
  const [showOrderSbDouble3SeptemberForm, setShowOrderSbDouble3SeptemberForm] =
    useState(false);

  // 10 September 2025
  const [showSbThaifDetail, setShowSbThaifDetail] = useState(false); // September Berkah Plus Thaif
  const [showSmjThaifDetail, setShowSmjThaifDetail] = useState(false); // September Munajat Plus Thaif
  const [
    showOrderSbThaifQuad10SeptemberForm,
    setShowOrderSbThaifQuad10SeptemberForm,
  ] = useState(false);
  const [
    showOrderSbThaifTriple10SeptemberForm,
    setShowOrderSbThaifTriple10SeptemberForm,
  ] = useState(false);
  const [
    showOrderSbThaifDouble10SeptemberForm,
    setShowOrderSbThaifDouble10SeptemberForm,
  ] = useState(false);

  const [
    showOrderSmjThaifQuad10SeptemberForm,
    setShowOrderSmjThaifQuad10SeptemberForm,
  ] = useState(false);
  const [
    showOrderSmjThaifTriple10SeptemberForm,
    setShowOrderSmjThaifTriple10SeptemberForm,
  ] = useState(false);
  const [
    showOrderSmjThaifDouble10SeptemberForm,
    setShowOrderSmjThaifDouble10SeptemberForm,
  ] = useState(false);

  // 15 September 2025
  const [showSbLimabelasDetail, setShowSbLimabelasDetail] = useState(false); // September Berkah 15
  const [showSmtDetail, setShowSmtDetail] = useState(false); // September Mumtaaz
  const [
    showOrderSbLimabelasQuad15SeptemberForm,
    setShowOrderSbLimabelasQuad15SeptemberForm,
  ] = useState(false);
  const [
    showOrderSbLimabelasTriple15SeptemberForm,
    setShowOrderSbLimabelasTriple15SeptemberForm,
  ] = useState(false);
  const [
    showOrderSbLimabelasDouble15SeptemberForm,
    setShowOrderSbLimabelasDouble15SeptemberForm,
  ] = useState(false);

  const [showOrderSmtQuad15SeptemberForm, setShowOrderSmtQuad15SeptemberForm] =
    useState(false);
  const [
    showOrderSmtTriple15SeptemberForm,
    setShowOrderSmtTriple15SeptemberForm,
  ] = useState(false);
  const [
    showOrderSmtDouble15SeptemberForm,
    setShowOrderSmtDouble15SeptemberForm,
  ] = useState(false);

  // 24 September 2025
  const [showSpbDetail, setShowSpbDetail] = useState(false); // September Plus Dubai
  const [showOrderSpbQuad24SeptemberForm, setShowOrderSpbQuad24SeptemberForm] =
    useState(false);
  const [
    showOrderSpbTriple24SeptemberForm,
    setShowOrderSpbTriple24SeptemberForm,
  ] = useState(false);
  const [
    showOrderSpbDouble24SeptemberForm,
    setShowOrderSpbDouble24SeptemberForm,
  ] = useState(false);

  // 6 Oktober 2025
  const [showOabDetail, setShowOabDetail] = useState(false); // Oktober Akbar Berkah
  const [showOamDetail, setShowOamDetail] = useState(false); // Oktober Akbar Mumtaaz
  const [showOrderOabQuad6OktoberForm, setShowOrderOabQuad6OktoberForm] =
    useState(false);
  const [showOrderOabTriple6OktoberForm, setShowOrderOabTriple6OktoberForm] =
    useState(false);
  const [showOrderOabDouble6OktoberForm, setShowOrderOabDouble6OktoberForm] =
    useState(false);

  const [showOrderOamQuad6OktoberForm, setShowOrderOamQuad6OktoberForm] =
    useState(false);
  const [showOrderOamTriple6OktoberForm, setShowOrderOamTriple6OktoberForm] =
    useState(false);
  const [showOrderOamDouble6OktoberForm, setShowOrderOamDouble6OktoberForm] =
    useState(false);

  // 20 Oktober 2025
  const [showObThaifDetail, setShowObThaifDetail] = useState(false); // Oktober Berkah Thaif
  const [
    showOrderObThaifQuad20OktoberForm,
    setShowOrderObThaifQuad20OktoberForm,
  ] = useState(false);
  const [
    showOrderObThaifTriple20OktoberForm,
    setShowOrderObThaifTriple20OktoberForm,
  ] = useState(false);
  const [
    showOrderObThaifDouble20OktoberForm,
    setShowOrderObThaifDouble20OktoberForm,
  ] = useState(false);

  // 03 November 2025
  const [showNmfsDetail, setShowNmfsDetail] = useState(false); // November Munajat Family Series
  const [showOrderNmfsQuad3NovemberForm, setShowOrderNmfsQuad3NovemberForm] =
    useState(false);

  const [
    showOrderNmfsTriple3NovemberForm,
    setShowOrderNmfsTriple3NovemberForm,
  ] = useState(false);

  const [
    showOrderNmfsDouble3NovemberForm,
    setShowOrderNmfsDouble3NovemberForm,
  ] = useState(false);

  // 05 November 2025
  const [showNbDetail, setShowNbDetail] = useState(false); // November berkah
  const [showOrderNbQuad5NovemberForm, setShowOrderNbQuad5NovemberForm] =
    useState(false);
  const [showOrderNbTriple5NovemberForm, setShowOrderNbTriple5NovemberForm] =
    useState(false);
  const [showOrderNbDouble5NovemberForm, setShowOrderNbDouble5NovemberForm] =
    useState(false);

  // 19 November 2025
  const [showNpdsddDetail, setShowNpdsddDetail] = useState(false); // November Plus Dubai Safari Dessert Dubai
  const [
    showOrderNpdsdQuad19NovemberForm,
    setShowOrderNpdsdQuad19NovemberForm,
  ] = useState(false);
  const [
    showOrderNpdsdTriple19NovemberForm,
    setShowOrderNpdsdTriple19NovemberForm,
  ] = useState(false);
  const [
    showOrderNpdsdDouble19NovemberForm,
    setShowOrderNpdsdDouble19NovemberForm,
  ] = useState(false);

  // 26 November 2025
  const [showNlbDetail, setShowNlbDetail] = useState(false); // November lion berkah
  const [showOrderNlbQuad26NovemberForm, setShowOrderNlbdQuad26NovemberForm] =
    useState(false);
  const [
    showOrderNlbTriple26NovemberForm,
    setShowOrderNlbdTriple26NovemberForm,
  ] = useState(false);
  const [
    showOrderNlbDouble26NovemberForm,
    setShowOrderNlbdDouble26NovemberForm,
  ] = useState(false);

  // 3 Desember 2025
  const [showDbsatDetail, setShowDbsatDetail] = useState(false); // Desember berkah spesial akhir tahun
  const [showOrderDbsatQuad3DesemberForm, setShowOrderDbsatQuad3DesemberForm] =
    useState(false);
  const [
    showOrderDbsatTriple3DesemberForm,
    setShowOrderDbsatTriple3DesemberForm,
  ] = useState(false);
  const [
    showOrderDbsatDouble3DesemberForm,
    setShowOrderDbsatDouble3DesemberForm,
  ] = useState(false);

  // 24 Desember 2025
  const [showDbfsDetail, setShowDbfsDetail] = useState(false);
  const [showOrderDbfsQuad24DesemberForm, setShowOrderDbfsQuad24DesemberForm] =
    useState(false);
  const [
    showOrderDbfsTriple24DesemberForm,
    setShowOrderDbfsTriple24DesemberForm,
  ] = useState(false);
  const [
    showOrderDbfsDouble24DesemberForm,
    setShowOrderDbfsDouble24DesemberForm,
  ] = useState(false);

  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedDate, setSelectedDate] = useState(null);
  const [showMonthButtons, setShowMonthButtons] = useState(true);

  const [showContacts, setShowContacts] = useState(false);

  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [dob, setDob] = useState('');
  const [gender, setGender] = useState('');
  const [address, setAddress] = useState('');
  const [email, setEmail] = useState('');
  const [ktp, setKtp] = useState('');
  const [kk, setKk] = useState('');
  const [photo, setPhoto] = useState('');
  const [passport, setPassport] = useState('');
  const [message, setMessage] = useState(
    'Saya berniat Ingin Pergi Ke Tanah Suci'
  );

  useEffect(() => {
    if (window.location.hash === '#paket-umrah') {
      const paketUmrahSection = document.getElementById('paket-umrah');
      if (paketUmrahSection) {
        paketUmrahSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [window.location.hash]);

  // 31 Juli
  const handleJmsmClick = (e) => {
    e.preventDefault();
    navigate('#paket-umrah');
    setShowJmsmDetail(!showJmsmDetail);
    setShowJbsmDetail(false);
  };
  const handleJbsmClick = (e) => {
    e.preventDefault();
    navigate('#paket-umrah');
    setShowJbsmDetail(!showJbsmDetail);
    setShowJmsmDetail(false);
  };

  const toggleOrderJsbQuad1JuliForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderJsbQuad1JuliForm(!showOrderJsbQuad1JuliForm);
  };

  const toggleOrderJsbTriple1JuliForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderJsbTriple1JuliForm(!showOrderJsbTriple1JuliForm);
  };

  const toggleOrderJsbDouble1JuliForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderJsbDouble1JuliForm(!showOrderJsbDouble1JuliForm);
  };

  const toggleOrderJbsmQuad31JuliForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderJbsmQuad31JuliForm(!showOrderJbsmQuad31JuliForm);
  };

  const toggleOrderJbsmTriple31JuliForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderJbsmTriple31JuliForm(!showOrderJbsmTriple31JuliForm);
  };

  const toggleOrderJbsmDouble31JuliForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderJbsmDouble31JuliForm(!showOrderJbsmDouble31JuliForm);
  };

  const toggleOrderJmsmQuad31JuliForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderJmsmQuad31JuliForm(!showOrderJmsmQuad31JuliForm);
  };

  const toggleOrderJmsmTriple31JuliForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderJmsmTriple31JuliForm(!showOrderJmsmTriple31JuliForm);
  };

  const toggleOrderJmsmDouble31JuliForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderJmsmDouble31JuliForm(!showOrderJmsmDouble31JuliForm);
  };

  //8 Agustus
  const handleAmtfsClick = (e) => {
    e.preventDefault();
    navigate('#paket-umrah');
    setShowAmtfsDetail(!showAmtfsDetail);
    setShowAmbfsDetail(false);
  };
  const handleAmbfsClick = (e) => {
    e.preventDefault();
    navigate('#paket-umrah');
    setShowAmbfsDetail(!showAmbfsDetail);
    setShowAmtfsDetail(false);
  };

  const toggleOrderAmtfsQuad8AgustusForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderAmtfsQuad8AgustusForm(!showOrderAmtfsQuad8AgustusForm);
  };

  const toggleOrderAmtfsTriple8AgustusForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderAmtfsTriple8AgustusForm(!showOrderAmtfsTriple8AgustusForm);
  };

  const toggleOrderAmtfsDouble8AgustusForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderAmtfsDouble8AgustusForm(!showOrderAmtfsDouble8AgustusForm);
  };

  const toggleOrderAmbfsQuad8AgustusForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderAmbfsQuad8AgustusForm(!showOrderAmbfsQuad8AgustusForm);
  };

  const toggleOrderAmbfsTriple8AgustusForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderAmbfsTriple8AgustusForm(!showOrderAmbfsTriple8AgustusForm);
  };

  const toggleOrderAmbfsDouble8AgustusForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderAmbfsDouble8AgustusForm(!showOrderAmbfsDouble8AgustusForm);
  };

  // 18 Agustus
  const handleAsbthaifsmClick = (e) => {
    e.preventDefault();
    navigate('#paket-umrah');
    setShowAsbthaifsmDetail(!showAsbthaifsmDetail);
    setShowAsmthaifsmDetail(false);
  };
  const handleAsmthaifsmClick = (e) => {
    e.preventDefault();
    navigate('#paket-umrah');
    setShowAsmthaifsmDetail(!showAsmthaifsmDetail);
    setShowAsbthaifsmDetail(false);
  };
  const toggleOrderAsbthaifQuad18AgustusForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderAsbthaifQuad18AgustusForm(!showOrderAsbthaifQuad18AgustusForm);
  };

  const toggleOrderAsbthaifTriple18AgustusForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderAsbthaifTriple18AgustusForm(
      !showOrderAsbthaifTriple18AgustusForm
    );
  };

  const toggleOrderAsbthaifDouble18AgustusForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderAsbthaifDouble18AgustusForm(
      !showOrderAsbthaifDouble18AgustusForm
    );
  };

  const toggleOrderAsmthaifQuad18AgustusForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderAsmthaifQuad18AgustusForm(!showOrderAsmthaifQuad18AgustusForm);
  };

  const toggleOrderAsmthaifTriple18AgustusForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderAsmthaifTriple18AgustusForm(
      !showOrderAsmthaifTriple18AgustusForm
    );
  };

  const toggleOrderAsmthaifDouble18AgustusForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderAsmthaifDouble18AgustusForm(
      !showOrderAsmthaifDouble18AgustusForm
    );
  };

  // 27 Agustus 2025
  const toggleOrderAbQuad27AgustusForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderAbQuad27AgustusForm(!showOrderAbQuad27AgustusForm);
  };

  const toggleOrderAbTriple27AgustusForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderAbTriple27AgustusForm(!showOrderAbTriple27AgustusForm);
  };

  const toggleOrderAbDouble27AgustusForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderAbDouble27AgustusForm(!showOrderAbDouble27AgustusForm);
  };

  // 3 September 2025
  const toggleOrderSbQuad3SeptemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderSbQuad3SeptemberForm(!showOrderSbQuad3SeptemberForm);
  };

  const toggleOrderSbTriple3SeptemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderSbTriple3SeptemberForm(!showOrderSbTriple3SeptemberForm);
  };

  const toggleOrderSbDouble3SeptemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderSbDouble3SeptemberForm(!showOrderSbDouble3SeptemberForm);
  };

  // 10 September 2025
  const handleSbThaifClick = (e) => {
    e.preventDefault();
    navigate('#paket-umrah');
    setShowSbThaifDetail(!showSbThaifDetail);
    setShowSmjThaifDetail(false);
  };
  const handleSmjThaifClick = (e) => {
    e.preventDefault();
    navigate('#paket-umrah');
    setShowSmjThaifDetail(!showSmjThaifDetail);
    setShowSbThaifDetail(false);
  };

  const toggleOrderSbThaifQuad10SeptemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderSbThaifQuad10SeptemberForm(
      !showOrderSbThaifQuad10SeptemberForm
    );
  };

  const toggleOrderSbThaifTriple10SeptemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderSbThaifTriple10SeptemberForm(
      !showOrderSbThaifTriple10SeptemberForm
    );
  };

  const toggleOrderSbThaifDouble10SeptemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderSbThaifDouble10SeptemberForm(
      !showOrderSbThaifDouble10SeptemberForm
    );
  };

  const toggleOrderSmjThaifQuad10SeptemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderSmjThaifQuad10SeptemberForm(
      !showOrderSmjThaifQuad10SeptemberForm
    );
  };

  const toggleOrderSmjThaifTriple10SeptemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderSmjThaifTriple10SeptemberForm(
      !showOrderSmjThaifTriple10SeptemberForm
    );
  };

  const toggleOrderSmjThaifDouble10SeptemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderSmjThaifDouble10SeptemberForm(
      !showOrderSmjThaifDouble10SeptemberForm
    );
  };

  // 15 September 2025
  const handleSbLimaBelasClick = (e) => {
    e.preventDefault();
    navigate('#paket-umrah');
    setShowSbLimabelasDetail(!showSbLimabelasDetail);
    setShowSmtDetail(false);
  };
  const handleSmtClick = (e) => {
    e.preventDefault();
    navigate('#paket-umrah');
    setShowSmtDetail(!showSmtDetail);
    setShowSbLimabelasDetail(false);
  };

  const toggleOrderSbLimabelasQuad15SeptemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderSbLimabelasQuad15SeptemberForm(
      !showOrderSbLimabelasQuad15SeptemberForm
    );
  };

  const toggleOrderSbLimabelasTriple15SeptemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderSbLimabelasTriple15SeptemberForm(
      !showOrderSbLimabelasTriple15SeptemberForm
    );
  };

  const toggleOrderSbLimabelasDouble15SeptemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderSbLimabelasDouble15SeptemberForm(
      !showOrderSbLimabelasDouble15SeptemberForm
    );
  };

  const toggleOrderSmtQuad15SeptemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderSmtQuad15SeptemberForm(!showOrderSmtQuad15SeptemberForm);
  };

  const toggleOrderSmtTriple15SeptemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderSmtTriple15SeptemberForm(!showOrderSmtTriple15SeptemberForm);
  };

  const toggleOrderSmtDouble15SeptemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderSmtDouble15SeptemberForm(!showOrderSmtDouble15SeptemberForm);
  };

  // 24 September
  const toggleOrderSpbQuad24SeptemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderSpbQuad24SeptemberForm(!showOrderSpbQuad24SeptemberForm);
  };

  const toggleOrderSpbTriple24SeptemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderSpbTriple24SeptemberForm(!showOrderSpbTriple24SeptemberForm);
  };

  const toggleOrderSpbDouble24SeptemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderSpbDouble24SeptemberForm(!showOrderSpbDouble24SeptemberForm);
  };

  // 6 Oktober 2025
  const handleOabClick = (e) => {
    e.preventDefault();
    navigate('#paket-umrah');
    setShowOabDetail(!showOabDetail);
    setShowOamDetail(false);
  };
  const handleOamClick = (e) => {
    e.preventDefault();
    navigate('#paket-umrah');
    setShowOamDetail(!showOamDetail);
    setShowOabDetail(false);
  };

  const toggleOrderOabQuad6OktoberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderOabQuad6OktoberForm(!showOrderOabQuad6OktoberForm);
  };

  const toggleOrderOabTriple6OktoberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderOabTriple6OktoberForm(!showOrderOabTriple6OktoberForm);
  };

  const toggleOrderOabDouble6OktoberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderOabDouble6OktoberForm(!showOrderOabDouble6OktoberForm);
  };

  const toggleOrderOamQuad6OktoberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderOamQuad6OktoberForm(!showOrderOamQuad6OktoberForm);
  };

  const toggleOrderOamTriple6OktoberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderOamTriple6OktoberForm(!showOrderOamTriple6OktoberForm);
  };

  const toggleOrderOamDouble6OktoberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderOamDouble6OktoberForm(!showOrderOamDouble6OktoberForm);
  };

  // 20 Oktober 2025
  const toggleOrderObThaifQuad20OktoberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderObThaifQuad20OktoberForm(!showOrderObThaifQuad20OktoberForm);
  };

  const toggleOrderObThaifTriple20OktoberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderObThaifTriple20OktoberForm(
      !showOrderObThaifTriple20OktoberForm
    );
  };

  const toggleOrderObThaifDouble20OktoberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderObThaifDouble20OktoberForm(
      !showOrderObThaifDouble20OktoberForm
    );
  };

  const toggleContacts = () => {
    setShowContacts(!showContacts);
  };

  //03 November 2025
  const toggleOrderNmfsQuad3NovemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderNmfsQuad3NovemberForm(!showOrderNmfsQuad3NovemberForm);
  };

  const toggleOrderNmfsTriple3NovemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderNmfsTriple3NovemberForm(!showOrderNmfsTriple3NovemberForm);
  };

  const toggleOrderNmfsDouble3NovemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderNmfsDouble3NovemberForm(!showOrderNmfsDouble3NovemberForm);
  };

  // 05 November 2025
  const toggleOrderNbQuad5NovemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderNbQuad5NovemberForm(!showOrderNbQuad5NovemberForm);
  };

  const toggleOrderNbTriple5NovemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderNbTriple5NovemberForm(!showOrderNbTriple5NovemberForm);
  };

  const toggleOrderNbDouble5NovemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderNbDouble5NovemberForm(!showOrderNbDouble5NovemberForm);
  };

  // 19 November 2025
  const toggleOrderNpdsdQuad19NovemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderNpdsdQuad19NovemberForm(!showOrderNpdsdQuad19NovemberForm);
  };

  const toggleOrderNpdsdTriple19NovemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderNpdsdTriple19NovemberForm(!showOrderNpdsdTriple19NovemberForm);
  };

  const toggleOrderNpdsdDouble19NovemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderNpdsdDouble19NovemberForm(!showOrderNpdsdDouble19NovemberForm);
  };

  // 26 November 2025
  const toggleOrderNlbQuad26NovemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderNlbdQuad26NovemberForm(!showOrderNlbQuad26NovemberForm);
  };

  const toggleOrderNlbTriple26NovemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderNlbdTriple26NovemberForm(!showOrderNlbTriple26NovemberForm);
  };

  const toggleOrderNlbDouble26NovemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderNlbdDouble26NovemberForm(!showOrderNlbDouble26NovemberForm);
  };

  // 03 Desember 2024
  const toggleOrderDbsatQuad3DesemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderDbsatQuad3DesemberForm(!showOrderDbsatQuad3DesemberForm);
  };

  const toggleOrderDbsatTriple3DesemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderDbsatTriple3DesemberForm(!showOrderDbsatTriple3DesemberForm);
  };

  const toggleOrderDbsatDouble3DesemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderDbsatDouble3DesemberForm(!showOrderDbsatDouble3DesemberForm);
  };

  const toggleOrderDbfsQuad24DesemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderDbfsQuad24DesemberForm(!showOrderDbfsQuad24DesemberForm);
  };

  const toggleOrderDbfsTriple24DesemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderDbfsTriple24DesemberForm(!showOrderDbfsTriple24DesemberForm);
  };

  const toggleOrderDbfsDouble24DesemberForm = (e) => {
    e.preventDefault();
    navigate('#paket-umrah-order');
    setShowOrderDbfsDouble24DesemberForm(!showOrderDbfsDouble24DesemberForm);
  };

  // Juli
  const handleSubmitOrderJsbQuad1Juli = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleJsbQuad1Juli}*
      Harga: *${packagePriceJsbQuad1Juli}*
      Tanggal: *${hiddenJsbQuad1JuliDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderJsbTriple1Juli = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleJsbTriple1Juli}*
      Harga: *${packagePriceJsbTriple1Juli}*
      Tanggal: *${hiddenJsbTriple1JuliDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderJsbDouble1Juli = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleJsbDouble1Juli}*
      Harga: *${packagePriceJsbDouble1Juli}*
      Tanggal: *${hiddenJsbDouble1JuliDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderJbsmQuad31Juli = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleJbsmQuad31Juli}*
      Harga: *${packagePriceJbsmQuad31Juli}*
      Tanggal: *${hiddenJbsmQuad31JuliDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderJbsmTriple31Juli = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleJbsmTriple31Juli}*
      Harga: *${packagePriceJbsmTriple31Juli}*
      Tanggal: *${hiddenJbsmTriple31JuliDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderJbsmDouble31Juli = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleJbsmDouble31Juli}*
      Harga: *${packagePriceJbsmDouble31Juli}*
      Tanggal: *${hiddenJbsmDouble31JuliDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderJmsmQuad31Juli = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleJmsmQuad31Juli}*
      Harga: *${packagePriceJmsmQuad31Juli}*
      Tanggal: *${hiddenJmsmQuad31JuliDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderJmsmTriple31Juli = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleJmsmTriple31Juli}*
      Harga: *${packagePriceJmsmTriple31Juli}*
      Tanggal: *${hiddenJmsmTriple31JuliDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderJmsmDouble31Juli = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleJmsmDouble31Juli}*
      Harga: *${packagePriceJmsmDouble31Juli}*
      Tanggal: *${hiddenJmsmDouble31JuliDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  // Agustus
  const handleSubmitOrderAmtfsQuad8Agustus = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleAmtfsQuad8Agustus}*
      Harga: *${packagePriceAmtfsQuad8Agustus}*
      Tanggal: *${hiddenAmtfsQuad8AgustusDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderAmtfsTriple8Agustus = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleAmtfsTriple8Agustus}*
      Harga: *${packagePriceAmtfsTriple8Agustus}*
      Tanggal: *${hiddenAmtfsTriple8AgustusDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderAmtfsDouble8Agustus = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleAmtfsDouble8Agustus}*
      Harga: *${packagePriceAmtfsDouble8Agustus}*
      Tanggal: *${hiddenAmtfsDouble8AgustusDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderAmbfsQuad8Agustus = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleAmbfsQuad8Agustus}*
      Harga: *${packagePriceAmbfsQuad8Agustus}*
      Tanggal: *${hiddenAmbfsQuad8AgustusDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderAmbfsTriple8Agustus = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleAmbfsTriple8Agustus}*
      Harga: *${packagePriceAmbfsTriple8Agustus}*
      Tanggal: *${hiddenAmbfsTriple8AgustusDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderAmbfsDouble8Agustus = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleAmbfsDouble8Agustus}*
      Harga: *${packagePriceAmbfsDouble8Agustus}*
      Tanggal: *${hiddenAmbfsDouble8AgustusDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderAsbthaifQuad18Agustus = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleAsbthaifQuad18Agustus}*
      Harga: *${packagePriceAsbthaifQuad18Agustus}*
      Tanggal: *${hiddenAsbthaifQuad18AgustusDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderAsbthaifTriple18Agustus = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleAsbthaifTriple18Agustus}*
      Harga: *${packagePriceAsbthaifTriple18Agustus}*
      Tanggal: *${hiddenAsbthaifTriple18AgustusDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderAsbthaifDouble18Agustus = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleAsbthaifDouble18Agustus}*
      Harga: *${packagePriceAsbthaifDouble18Agustus}*
      Tanggal: *${hiddenAsbthaifDouble18AgustusDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderAsmthaifQuad18Agustus = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleAsmthaifQuad18Agustus}*
      Harga: *${packagePriceAsmthaifQuad18Agustus}*
      Tanggal: *${hiddenAsmthaifQuad18AgustusDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderAsmthaifTriple18Agustus = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleAsmthaifTriple18Agustus}*
      Harga: *${packagePriceAsmthaifTriple18Agustus}*
      Tanggal: *${hiddenAsmthaifTriple18AgustusDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderAsmthaifDouble18Agustus = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleAsmthaifDouble18Agustus}*
      Harga: *${packagePriceAsmthaifDouble18Agustus}*
      Tanggal: *${hiddenAsmthaifDouble18AgustusDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderAbQuad27Agustus = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleAbQuad27Agustus}*
      Harga: *${packagePriceAbQuad27Agustus}*
      Tanggal: *${hiddenAbQuad27AgustusDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderAbTriple27Agustus = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleAbTriple27Agustus}*
      Harga: *${packagePriceAbTriple27Agustus}*
      Tanggal: *${hiddenAbTriple27AgustusDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderAbDouble27Agustus = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleAbDouble27Agustus}*
      Harga: *${packagePriceAbDouble27Agustus}*
      Tanggal: *${hiddenAbDouble27AgustusDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  // September
  const handleSubmitOrderSbQuad3September = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleSbQuad3September}*
      Harga: *${packagePriceSbQuad3September}*
      Tanggal: *${hiddenSbQuad3SeptemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderSbTriple3September = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleSbTriple3September}*
      Harga: *${packagePriceSbTriple3September}*
      Tanggal: *${hiddenSbTriple3SeptemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderSbDouble3September = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleSbDouble3September}*
      Harga: *${packagePriceSbDouble3September}*
      Tanggal: *${hiddenSbDouble3SeptemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderSbThaifQuad10September = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleSbThaifQuad10September}*
      Harga: *${packagePriceSbThaifQuad10September}*
      Tanggal: *${hiddenSbThaifQuad10SeptemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderSbThaifTriple10September = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleSbThaifTriple10September}*
      Harga: *${packagePriceSbThaifTriple10September}*
      Tanggal: *${hiddenSbThaifTriple10SeptemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderSbThaifDouble10September = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleSbThaifDouble10September}*
      Harga: *${packagePriceSbThaifDouble10September}*
      Tanggal: *${hiddenSbThaifDouble10SeptemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderSmjThaifQuad10September = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleSmjThaifQuad10September}*
      Harga: *${packagePriceSmjThaifQuad10September}*
      Tanggal: *${hiddenSmjThaifQuad10SeptemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderSmjThaifTriple10September = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleSmjThaifTriple10September}*
      Harga: *${packagePriceSmjThaifTriple10September}*
      Tanggal: *${hiddenSmjThaifTriple10SeptemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderSmjThaifDouble10September = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleSmjThaifDouble10September}*
      Harga: *${packagePriceSmjThaifDouble10September}*
      Tanggal: *${hiddenSmjThaifDouble10SeptemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderSbLimabelasQuad15September = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleSbLimabelasQuad15September}*
      Harga: *${packagePriceSbLimabelasQuad15September}*
      Tanggal: *${hiddenSbLimabelasQuad15SeptemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderSbLimabelasTriple15September = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleSbLimabelasTriple15September}*
      Harga: *${packagePriceSbLimabelasTriple15September}*
      Tanggal: *${hiddenSbLimabelasTriple15SeptemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderSbLimabelasDouble15September = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleSbLimabelasDouble15September}*
      Harga: *${packagePriceSbLimabelasDouble15September}*
      Tanggal: *${hiddenSbLimabelasDouble15SeptemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderSmtQuad15September = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleSmtQuad15September}*
      Harga: *${packagePriceSmtQuad15September}*
      Tanggal: *${hiddenSmtQuad15SeptemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderSmtTriple15September = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleSmtTriple15September}*
      Harga: *${packagePriceSmtTriple15September}*
      Tanggal: *${hiddenSmtTriple15SeptemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderSmtDouble15September = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleSmtDouble15September}*
      Harga: *${packagePriceSmtDouble15September}*
      Tanggal: *${hiddenSmtDouble15SeptemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderSpbQuad24September = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleSpbQuad24September}*
      Harga: *${packagePriceSpbQuad24September}*
      Tanggal: *${hiddenSpbQuad24SeptemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderSpbTriple24September = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleSpbTriple24September}*
      Harga: *${packagePriceSpbTriple24September}*
      Tanggal: *${hiddenSpbTriple24SeptemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderSpbDouble24September = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleSpbDouble24September}*
      Harga: *${packagePriceSpbDouble24September}*
      Tanggal: *${hiddenSpbDouble24SeptemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderOabQuad6Oktober = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleOabQuad6Oktober}*
      Harga: *${packagePriceOabQuad6Oktober}*
      Tanggal: *${hiddenOabQuad6OktoberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderOabTriple6Oktober = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleOabTriple6Oktober}*
      Harga: *${packagePriceOabTriple6Oktober}*
      Tanggal: *${hiddenOabTriple6OktoberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderOabDouble6Oktober = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleOabDouble6Oktober}*
      Harga: *${packagePriceOabDouble6Oktober}*
      Tanggal: *${hiddenOabDouble6OktoberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderOamQuad6Oktober = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleOamQuad6Oktober}*
      Harga: *${packagePriceOamQuad6Oktober}*
      Tanggal: *${hiddenOamQuad6OktoberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderOamTriple6Oktober = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleOamTriple6Oktober}*
      Harga: *${packagePriceOamTriple6Oktober}*
      Tanggal: *${hiddenOamTriple6OktoberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderOamDouble6Oktober = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleOamDouble6Oktober}*
      Harga: *${packagePriceOamDouble6Oktober}*
      Tanggal: *${hiddenOamDouble6OktoberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderObThaifQuad20Oktober = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleObThaifQuad20Oktober}*
      Harga: *${packagePriceObThaifQuad20Oktober}*
      Tanggal: *${hiddenObThaifQuad20OktoberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderObThaifTriple20Oktober = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleObThaifTriple20Oktober}*
      Harga: *${packagePriceObThaifTriple20Oktober}*
      Tanggal: *${hiddenObThaifTriple20OktoberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderObThaifDouble20Oktober = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleObThaifDouble20Oktober}*
      Harga: *${packagePriceObThaifDouble20Oktober}*
      Tanggal: *${hiddenObThaifDouble20OktoberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderNmfsQuad3November = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleNmfsQuad3November}*
      Harga: *${packagePriceNmfsQuad3November}*
      Tanggal: *${hiddenNmfsQuad3NovemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderNmfsTriple3November = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleNmfsTriple3November}*
      Harga: *${packagePriceNmfsTriple3November}*
      Tanggal: *${hiddenNmfsTriple3NovemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderNmfsDouble3November = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleNmfsDouble3November}*
      Harga: *${packagePriceNmfsDouble3November}*
      Tanggal: *${hiddenNmfsDouble3NovemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderNbQuad5November = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleNbQuad5November}*
      Harga: *${packagePriceNbQuad5November}*
      Tanggal: *${hiddenNbQuad5NovemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderNbTriple5November = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleNbTriple5November}*
      Harga: *${packagePriceNbTriple5November}*
      Tanggal: *${hiddenNbTriple5NovemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderNbDouble5November = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleNbDouble5November}*
      Harga: *${packagePriceNbDouble5November}*
      Tanggal: *${hiddenNbDouble5NovemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderNpdsdQuad19November = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleNpdsdQuad19November}*
      Harga: *${packagePriceNpdsdQuad19November}*
      Tanggal: *${hiddenNpdsdQuad19NovemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderNpdsdTriple19November = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleNpdsdTriple19November}*
      Harga: *${packagePriceNpdsdTriple19November}*
      Tanggal: *${hiddenNpdsdTriple19NovemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderNpdsdDouble19November = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleNpdsdDouble19November}*
      Harga: *${packagePriceNpdsdDouble19November}*
      Tanggal: *${hiddenNpdsdDouble19NovemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderNlbQuad26November = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleNlbQuad26November}*
      Harga: *${packagePriceNlbQuad26November}*
      Tanggal: *${hiddenNlbQuad26NovemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderNlbTriple26November = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleNlbTriple26November}*
      Harga: *${packagePriceNlbTriple26November}*
      Tanggal: *${hiddenNlbTriple26NovemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderNlbDouble26November = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleNlbDouble26November}*
      Harga: *${packagePriceNlbDouble26November}*
      Tanggal: *${hiddenNlbDouble26NovemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderDbsatQuad3Desember = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleDbsatQuad3Desember}*
      Harga: *${packagePriceDbsatQuad3Desember}*
      Tanggal: *${hiddenDbsatQuad3DesemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderDbsatTriple3Desember = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleDbsatTriple3Desember}*
      Harga: *${packagePriceDbsatTriple3Desember}*
      Tanggal: *${hiddenDbsatTriple3DesemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderDbsatDouble3Desember = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleDbsatDouble3Desember}*
      Harga: *${packagePriceDbsatDouble3Desember}*
      Tanggal: *${hiddenDbsatDouble3DesemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderDbfsQuad24Desember = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleDbfsQuad24Desember}*
      Harga: *${packagePriceDbfsQuad24Desember}*
      Tanggal: *${hiddenDbfsQuad24DesemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderDbfsTriple24Desember = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleDbfsTriple24Desember}*
      Harga: *${packagePriceDbfsTriple24Desember}*
      Tanggal: *${hiddenDbfsTriple24DesemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const handleSubmitOrderDbfsDouble24Desember = () => {
    // Membuat pesan yang berisi informasi yang diinginkan
    const orderMessage = `
      Pesan: *${message}*
      Paket: *${packageTitleDbfsDouble24Desember}*
      Harga: *${packagePriceDbfsDouble24Desember}*
      Tanggal: *${hiddenDbfsDouble24DesemberDate}*
      Nama: ${name}
      Email: ${email}
      Nomor Telepon: ${phone}
      Tanggal Lahir: ${dob}
      Jenis Kelamin: ${gender}
      Alamat: ${address}
      KTP: ${ktp}
      Kartu Keluarga: ${kk}
      Pas Foto: ${photo}
      Paspor: ${passport}
      `;

    const whatsappLink = `https://wa.me/6285156811979?text=${encodeURIComponent(orderMessage)}`;
    window.open(whatsappLink, '_blank');
  };

  const monthDates = {
    Januari: [],
    Februari: [],
    Maret: [],
    April: [],
    Mei: [],
    Juni: [],
    Juli: [1, 31],
    Agustus: [8, 18, 27],
    September: [3, 10, 15, 24],
    Oktober: [6, 20],
    November: [3, 5, 19, 26],
    Desember: [3, 24],
  };

  // Mendapatkan bulan saat ini
  const currentMonth = new Date().getMonth(); // Bulan sekarang (0-indexed, Januari = 0)
  const monthsArray = [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember',
  ];

  const handleMonthSelect = (month) => {
     window.location.hash = '#paket-umrah'; // Mengubah hash

    // Menunggu agar render selesai dan kemudian melakukan scroll
    setTimeout(() => {
      const paketUmrahSection = document.getElementById('paket-umrah');
      if (paketUmrahSection) {
        paketUmrahSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 0);

    setSelectedMonth(month);
    setSelectedDate(null); // Reset tanggal yang dipilih ketika bulan berubah
    setShowMonthButtons(false);
    // Juli
    setShowJsbThaifDetail(false);
    setShowJbsmDetail(false);
    setShowJmsmDetail(false);
    // Agustus
    setShowAmtfsDetail(false);
    setShowAmbfsDetail(false);
    setShowAsbthaifsmDetail(false);
    setShowAsmthaifsmDetail(false);
    setShowAbDetail(false);
    // September
    setShowSbDetail(false);
    setShowSbThaifDetail(false);
    setShowSmjThaifDetail(false);
    setShowSbLimabelasDetail(false);
    setShowSmtDetail(false);
    setShowSpbDetail(false);
    // Oktober
    setShowOabDetail(false);
    setShowOamDetail(false);
    setShowObThaifDetail(false);
    // November
    setShowNmfsDetail(false);
    setShowNbDetail(false);
    setShowNpdsddDetail(false);
    setShowNlbDetail(false);
    // Desember
    setShowDbsatDetail(false);
    setShowDbfsDetail(false);
  };

  // Function to handle date selection
  const handleDateSelect = (date) => {
     window.location.hash = '#paket-umrah'; // Mengubah hash

    // Menunggu agar render selesai dan kemudian melakukan scroll
    setTimeout(() => {
      const paketUmrahSection = document.getElementById('paket-umrah');
      if (paketUmrahSection) {
        paketUmrahSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 0);

    setSelectedDate(date);

    // Menyembunyikan semua detail terlebih dahulu
    // Juli
    setShowJsbThaifDetail(false);
    setShowJbsmDetail(false);
    setShowJmsmDetail(false);
    // Agustus
    setShowAmbfsDetail(false);
    setShowAmtfsDetail(false);
    setShowAsbthaifsmDetail(false);
    setShowAsmthaifsmDetail(false);
    setShowAbDetail(false);
    // September
    setShowSbDetail(false);
    setShowSbThaifDetail(false);
    setShowSmjThaifDetail(false);
    setShowSbLimabelasDetail(false);
    setShowSmtDetail(false);
    setShowSpbDetail(false);
    // Oktober
    setShowOabDetail(false);
    setShowOamDetail(false);
    setShowObThaifDetail(false);
    // November
    setShowNmfsDetail(false);
    setShowNbDetail(false);
    setShowNpdsddDetail(false);
    setShowNlbDetail(false);
    // Desember
    setShowDbsatDetail(false);
    setShowDbfsDetail(false);

    // Menampilkan detail Umroh berdasarkan bulan dan tanggal
    if (selectedMonth === 'Juli' && date === 1) {
      // Memunculkan Detail
      setShowJsbThaifDetail(true);
    } else if (selectedMonth === 'Agustus') {
      if (date === 8) {
        // Menyembunyikan Detail
        setShowAmbfsDetail(false);
        setShowAmtfsDetail(false);
      } else if (date === 18) {
        setShowAmbfsDetail(false);
        setShowAmtfsDetail(false);
        setShowAsbthaifsmDetail(false);
        setShowAsmthaifsmDetail(false);
      } else if (date === 27) {
        setShowAbDetail(true);
      }
    } else if (selectedMonth === 'September') {
      if (date === 3) {
        setShowSbDetail(true);
      } else if (date === 10) {
        setShowSbThaifDetail(false);
        setShowSmjThaifDetail(false);
      } else if (date === 15) {
        setShowSbLimabelasDetail(false);
        setShowSmtDetail(false);
      } else if (date === 24) {
        setShowSpbDetail(true);
      }
    } else if (selectedMonth === 'Oktober') {
      if (date === 6) {
        setShowOabDetail(false);
        setShowOamDetail(false);
      } else if (date === 20) {
        setShowObThaifDetail(true);
      }
    } else if (selectedMonth === 'November') {
      if (date === 3) {
        setShowNmfsDetail(true);
      } else if (date === 5) {
        setShowNbDetail(true);
      } else if (date === 19) {
        setShowNpdsddDetail(true);
      } else if (date === 26) {
        setShowNlbDetail(true);
      }
    } else if (selectedMonth === 'Desember') {
      if (date === 3) {
        setShowDbsatDetail(true);
      } else if (date === 24) {
        setShowDbfsDetail(true);
      }
    }
  };

  const handleBack = () => {
    window.location.hash = '#paket-umrah'; // Mengubah hash

    // Menunggu agar render selesai dan kemudian melakukan scroll
    setTimeout(() => {
      const paketUmrahSection = document.getElementById('paket-umrah');
      if (paketUmrahSection) {
        paketUmrahSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 0);

    setSelectedMonth(''); // Reset bulan
    setSelectedDate(null); // Reset tanggal
    setShowMonthButtons(true);
    // Juli
    setShowJsbThaifDetail(false);
    setShowJmsmDetail(false);
    setShowJbsmDetail(false);
    // Agustus
    setShowAmtfsDetail(false);
    setShowAmbfsDetail(false);
    setShowAsbthaifsmDetail(false);
    setShowAsmthaifsmDetail(false);
    setShowAbDetail(false);
    // September
    setShowSbDetail(false);
    setShowSbThaifDetail(false);
    setShowSmjThaifDetail(false);
    setShowSbLimabelasDetail(false);
    setShowSmtDetail(false);
    setShowSpbDetail(false);
    // Oktober
    setShowOabDetail(false);
    setShowOamDetail(false);
    setShowObThaifDetail(false);
    // November
    setShowNmfsDetail(false);
    setShowNbDetail(false);
    setShowNpdsddDetail(false);
    setShowNlbDetail(false);
    // Desember
    setShowDbsatDetail(false);
    setShowDbfsDetail(false);
  };

  // Cek apakah bulan yang dipilih memiliki tanggal atau tidak
  const hasAvailableDates = monthDates[selectedMonth]?.length > 0;

  // Menambahkan logic untuk menonaktifkan tombol bulan yang sudah lewat
  const isMonthDisabled = (month) => {
    const monthIndex = monthsArray.indexOf(month);
    return monthIndex < currentMonth; // Menonaktifkan bulan yang sudah lewat
  };

  // Informasi Package Januari - Desember 2025
  // 1 Juli 2025
  const packageTitleJsbQuad1Juli =
    'Umrah Berkah Super Berkah Spesial Muharram Plus Thaif Paket Quad';
  const packagePriceJsbQuad1Juli = 'Rp. 26.9 Juta';
  const hiddenJsbQuad1JuliDate = '01 Juli 2025';

  const packageTitleJsbTriple1Juli =
    'Umrah Berkah Super Berkah Spesial Muharram Plus Thaif Paket Triple';
  const packagePriceJsbTriple1Juli = 'Rp. 29.4 Juta';
  const hiddenJsbTriple1JuliDate = '01 Juli 2025';

  const packageTitleJsbDouble1Juli =
    'Umrah Berkah Super Berkah Spesial Muharram Plus Thaif Paket Double';
  const packagePriceJsbDouble1Juli = 'Rp. 30.4 Juta';
  const hiddenJsbDouble1JuliDate = '01 Juli 2025';

  // 31 Juli 2025
  const packageTitleJbsmQuad31Juli = 'Umrah Berkah Spesial Muharram Paket Quad';
  const packagePriceJbsmQuad31Juli = 'Rp. 29.5 Juta';
  const hiddenJbsmQuad31JuliDate = '31 Juli 2025';

  const packageTitleJbsmTriple31Juli =
    'Umrah Berkah Spesial Muharram Paket Triple';
  const packagePriceJbsmTriple31Juli = 'Rp. 32 Juta';
  const hiddenJbsmTriple31JuliDate = '31 Juli 2025';

  const packageTitleJbsmDouble31Juli =
    'Umrah Berkah Spesial Muharram Paket Double';
  const packagePriceJbsmDouble31Juli = 'Rp. 33 Juta';
  const hiddenJbsmDouble31JuliDate = '31 Juli 2025';

  const packageTitleJmsmQuad31Juli =
    'Umrah Mumtaaz Spesial Muharram Paket Quad';
  const packagePriceJmsmQuad31Juli = 'Rp. 35 Juta';
  const hiddenJmsmQuad31JuliDate = '31 Juli 2025';

  const packageTitleJmsmTriple31Juli =
    'Umrah Mumtaaz Spesial Muharram Paket Triple';
  const packagePriceJmsmTriple31Juli = 'Rp. 37.5 Juta';
  const hiddenJmsmTriple31JuliDate = '31 Juli 2025';

  const packageTitleJmsmDouble31Juli =
    'Umrah Mumtaaz Spesial Muharram Paket Double';
  const packagePriceJmsmDouble31Juli = 'Rp. 38.5 Juta';
  const hiddenJmsmDouble31JuliDate = '31 Juli 2025';

  // 8 Agustus 2025
  const packageTitleAmtfsQuad8Agustus =
    'Umrah Mumtaaz Family Series Paket Quad';
  const packagePriceAmtfsQuad8Agustus = 'Rp. 36 Juta';
  const hiddenAmtfsQuad8AgustusDate = '08 Agustus 2025';

  const packageTitleAmtfsTriple8Agustus =
    'Umrah Mumtaaz Family Series Paket Triple';
  const packagePriceAmtfsTriple8Agustus = 'Rp. 38.5 Juta';
  const hiddenAmtfsTriple8AgustusDate = '08 Agustus 2025';

  const packageTitleAmtfsDouble8Agustus =
    'Umrah Mumtaaz Family Series Paket Double';
  const packagePriceAmtfsDouble8Agustus = 'Rp. 39.5 Juta';
  const hiddenAmtfsDouble8AgustusDate = '08 Agustus 2025';

  const packageTitleAmbfsQuad8Agustus =
    'Umrah Mahabbah Family Series Paket Quad';
  const packagePriceAmbfsQuad8Agustus = 'Rp. 38 Juta';
  const hiddenAmbfsQuad8AgustusDate = '08 Agustus 2025';

  const packageTitleAmbfsTriple8Agustus =
    'Umrah Mahabbah Family Series Paket Triple';
  const packagePriceAmbfsTriple8Agustus = 'Rp. 41.5 Juta';
  const hiddenAmbfsTriple8AgustusDate = '08 Agustus 2025';

  const packageTitleAmbfsDouble8Agustus =
    'Umrah Mahabbah Family Series Paket Double';
  const packagePriceAmbfsDouble8Agustus = 'Rp. 42.5 Juta';
  const hiddenAmbfsDouble8AgustusDate = '08 Agustus 2025';

  const packageTitleAsbthaifQuad18Agustus =
    'Umrah Syabab Berkah Thaif Spesial Muda-Mudi Paket Quad';
  const packagePriceAsbthaifQuad18Agustus = 'Rp. 28.5 Juta';
  const hiddenAsbthaifQuad18AgustusDate = '18 Agustus 2025';

  const packageTitleAsbthaifTriple18Agustus =
    'Umrah Syabab Berkah Thaif Spesial Muda-Mudi Paket Triple';
  const packagePriceAsbthaifTriple18Agustus = 'Rp. 32 Juta';
  const hiddenAsbthaifTriple18AgustusDate = '18 Agustus 2025';

  const packageTitleAsbthaifDouble18Agustus =
    'Umrah Syabab Berkah Thaif Spesial Muda-Mudi Paket Double';
  const packagePriceAsbthaifDouble18Agustus = 'Rp. 33 Juta';
  const hiddenAsbthaifDouble18AgustusDate = '18 Agustus 2025';

  const packageTitleAsmthaifQuad18Agustus =
    'Umrah Syabab Mahabbah Thaif Spesial Muda-Mudi Paket Quad';
  const packagePriceAsmthaifQuad18Agustus = 'Rp. 33.5 Juta';
  const hiddenAsmthaifQuad18AgustusDate = '18 Agustus 2025';

  const packageTitleAsmthaifTriple18Agustus =
    'Umrah Syabab Mahabbah Thaif Spesial Muda-Mudi Paket Triple';
  const packagePriceAsmthaifTriple18Agustus = 'Rp. 36 Juta';
  const hiddenAsmthaifTriple18AgustusDate = '18 Agustus 2025';

  const packageTitleAsmthaifDouble18Agustus =
    'Umrah Syabab Mahabbah Thaif Spesial Muda-Mudi Paket Double';
  const packagePriceAsmthaifDouble18Agustus = 'Rp. 37 Juta';
  const hiddenAsmthaifDouble18AgustusDate = '18 Agustus 2025';

  const packageTitleAbQuad27Agustus = 'Umrah Berkah Paket Quad';
  const packagePriceAbQuad27Agustus = 'Rp. 29.5 Juta';
  const hiddenAbQuad27AgustusDate = '27 Agustus 2025';

  const packageTitleAbTriple27Agustus = 'Umrah Berkah Paket Triple';
  const packagePriceAbTriple27Agustus = 'Rp. 32 Juta';
  const hiddenAbTriple27AgustusDate = '27 Agustus 2025';

  const packageTitleAbDouble27Agustus = 'Umrah Berkah Paket Double';
  const packagePriceAbDouble27Agustus = 'Rp. 33 Juta';
  const hiddenAbDouble27AgustusDate = '27 Agustus 2025';

  const packageTitleSbQuad3September = 'Umrah Berkah Paket Quad';
  const packagePriceSbQuad3September = 'Rp. 27.5 Juta';
  const hiddenSbQuad3SeptemberDate = '03 September 2025';

  const packageTitleSbTriple3September = 'Umrah Berkah Paket Triple';
  const packagePriceSbTriple3September = 'Rp. 30 Juta';
  const hiddenSbTriple3SeptemberDate = '03 September 2025';

  const packageTitleSbDouble3September = 'Umrah Berkah Paket Double';
  const packagePriceSbDouble3September = 'Rp. 31 Juta';
  const hiddenSbDouble3SeptemberDate = '03 September 2025';

  const packageTitleSbThaifQuad10September =
    'Umrah Berkah Plus Thaif Paket Quad';
  const packagePriceSbThaifQuad10September = 'Rp. 28.5 Juta';
  const hiddenSbThaifQuad10SeptemberDate = '10 September 2025';

  const packageTitleSbThaifTriple10September =
    'Umrah Berkah Plus Thaif Paket Triple';
  const packagePriceSbThaifTriple10September = 'Rp. 31 Juta';
  const hiddenSbThaifTriple10SeptemberDate = '10 September 2025';

  const packageTitleSbThaifDouble10September =
    'Umrah Berkah Plus Thaif Paket Double';
  const packagePriceSbThaifDouble10September = 'Rp. 32 Juta';
  const hiddenSbThaifDouble10SeptemberDate = '10 September 2025';

  const packageTitleSmjThaifQuad10September =
    'Umrah Munajat Plus Thaif Paket Quad';
  const packagePriceSmjThaifQuad10September = 'Rp. 32.9 Juta';
  const hiddenSmjThaifQuad10SeptemberDate = '10 September 2025';

  const packageTitleSmjThaifTriple10September =
    'Umrah Munajat Plus Thaif Paket Triple';
  const packagePriceSmjThaifTriple10September = 'Rp. 35.4 Juta';
  const hiddenSmjThaifTriple10SeptemberDate = '10 September 2025';

  const packageTitleSmjThaifDouble10September =
    'Umrah Munajat Plus Thaif Paket Double';
  const packagePriceSmjThaifDouble10September = 'Rp. 36.4 Juta';
  const hiddenSmjThaifDouble10SeptemberDate = '10 September 2025';

  const packageTitleSbLimabelasQuad15September = 'Umrah Berkah Paket Quad';
  const packagePriceSbLimabelasQuad15September = 'Rp. 29.5 Juta';
  const hiddenSbLimabelasQuad15SeptemberDate = '15 September 2025';

  const packageTitleSbLimabelasTriple15September = 'Umrah Berkah Paket Triple';
  const packagePriceSbLimabelasTriple15September = 'Rp. 32 Juta';
  const hiddenSbLimabelasTriple15SeptemberDate = '15 September 2025';

  const packageTitleSbLimabelasDouble15September = 'Umrah Berkah Paket Double';
  const packagePriceSbLimabelasDouble15September = 'Rp. 33 Juta';
  const hiddenSbLimabelasDouble15SeptemberDate = '15 September 2025';

  const packageTitleSmtQuad15September = 'Umrah Mumtaaz Paket Quad';
  const packagePriceSmtQuad15September = 'Rp. 36 Juta';
  const hiddenSmtQuad15SeptemberDate = '15 September 2025';

  const packageTitleSmtTriple15September = 'Umrah Mumtaaz Paket Triple';
  const packagePriceSmtTriple15September = 'Rp. 38.5 Juta';
  const hiddenSmtTriple15SeptemberDate = '15 September 2025';

  const packageTitleSmtDouble15September = 'Umrah Mumtaaz Paket Double';
  const packagePriceSmtDouble15September = 'Rp. 39.5 Juta';
  const hiddenSmtDouble15SeptemberDate = '15 September 2025';

  const packageTitleSpbQuad24September = 'Umrah Plus Dubai Paket Quad';
  const packagePriceSpbQuad24September = 'Rp. 33.9 Juta';
  const hiddenSpbQuad24SeptemberDate = '24 September 2025';

  const packageTitleSpbTriple24September = 'Umrah Plus Dubai Paket Triple';
  const packagePriceSpbTriple24September = 'Rp. 36.4 Juta';
  const hiddenSpbTriple24SeptemberDate = '24 September 2025';

  const packageTitleSpbDouble24September = 'Umrah Plus Dubai Paket Double';
  const packagePriceSpbDouble24September = 'Rp. 37.4 Juta';
  const hiddenSpbDouble24SeptemberDate = '24 September 2025';

  const packageTitleOabQuad6Oktober = 'Umrah Akbar Berkah Paket Quad';
  const packagePriceOabQuad6Oktober = 'Rp. 29.5 Juta';
  const hiddenOabQuad6OktoberDate = '06 Oktober 2025';

  const packageTitleOabTriple6Oktober = 'Umrah Akbar Berkah Paket Triple';
  const packagePriceOabTriple6Oktober = 'Rp. 32 Juta';
  const hiddenOabTriple6OktoberDate = '06 Oktober 2025';

  const packageTitleOabDouble6Oktober = 'Umrah Akbar Berkah Paket Double';
  const packagePriceOabDouble6Oktober = 'Rp. 33 Juta';
  const hiddenOabDouble6OktoberDate = '06 Oktober 2025';

  const packageTitleOamQuad6Oktober = 'Umrah Akbar Berkah Mumtaaz Paket Quad';
  const packagePriceOamQuad6Oktober = 'Rp. 36 Juta';
  const hiddenOamQuad6OktoberDate = '06 Oktober 2025';

  const packageTitleOamTriple6Oktober =
    'Umrah Akbar Berkah Mumtaaz Paket Triple';
  const packagePriceOamTriple6Oktober = 'Rp. 38.5 Juta';
  const hiddenOamTriple6OktoberDate = '06 Oktober 2025';

  const packageTitleOamDouble6Oktober =
    'Umrah Akbar Berkah Mumtaaz Paket Double';
  const packagePriceOamDouble6Oktober = 'Rp. 39.5 Juta';
  const hiddenOamDouble6OktoberDate = '06 Oktober 2025';

  const packageTitleObThaifQuad20Oktober = 'Umrah Berkah Plus Thaif Paket Quad';
  const packagePriceObThaifQuad20Oktober = 'Rp. 28.5 Juta';
  const hiddenObThaifQuad20OktoberDate = '20 Oktober 2025';

  const packageTitleObThaifTriple20Oktober =
    'Umrah Berkah Plus Thaif Paket Triple';
  const packagePriceObThaifTriple20Oktober = 'Rp. 31 Juta';
  const hiddenObThaifTriple20OktoberDate = '20 Oktober 2025';

  const packageTitleObThaifDouble20Oktober =
    'Umrah Berkah Plus Thaif Paket Double';
  const packagePriceObThaifDouble20Oktober = 'Rp. 32 Juta';
  const hiddenObThaifDouble20OktoberDate = '20 Oktober 2025';

  const packageTitleNmfsQuad3November =
    'Umrah Munajat Family Series Paket Quad';
  const packagePriceNmfsQuad3November = 'Rp. 35.5 Juta';
  const hiddenNmfsQuad3NovemberDate = '03 November 2025';

  const packageTitleNmfsTriple3November =
    'Umrah Munajat Family Series Paket Triple';
  const packagePriceNmfsTriple3November = 'Rp. 38 Juta';
  const hiddenNmfsTriple3NovemberDate = '03 November 2025';

  const packageTitleNmfsDouble3November =
    'Umrah Munajat Family Series Paket Double';
  const packagePriceNmfsDouble3November = 'Rp. 39 Juta';
  const hiddenNmfsDouble3NovemberDate = '03 November 2025';

  const packageTitleNbQuad5November = 'Umrah Berkah Paket Quad';
  const packagePriceNbQuad5November = 'Rp. 27.9 Juta';
  const hiddenNbQuad5NovemberDate = '05 November 2025';

  const packageTitleNbTriple5November = 'Umrah Berkah Paket Triple';
  const packagePriceNbTriple5November = 'Rp. 30.4 Juta';
  const hiddenNbTriple5NovemberDate = '05 November 2025';

  const packageTitleNbDouble5November = 'Umrah Berkah Paket Double';
  const packagePriceNbDouble5November = 'Rp. 31.4 Juta';
  const hiddenNbDouble5NovemberDate = '05 November 2025';

  const packageTitleNpdsdQuad19November =
    'Umrah Plus Dubai Safari Dessert Dubai Paket Quad';
  const packagePriceNpdsdQuad19November = 'Rp. 36.9 Juta';
  const hiddenNpdsdQuad19NovemberDate = '19 November 2025';

  const packageTitleNpdsdTriple19November =
    'Umrah Plus Dubai Safari Dessert Dubai Paket Triple';
  const packagePriceNpdsdTriple19November = 'Rp. 40.4 Juta';
  const hiddenNpdsdTriple19NovemberDate = '19 November 2025';

  const packageTitleNpdsdDouble19November =
    'Umrah Plus Dubai Safari Dessert Dubai Paket Double';
  const packagePriceNpdsdDouble19November = 'Rp. 41.4 Juta';
  const hiddenNpdsdDouble19NovemberDate = '19 November 2025';

  const packageTitleNlbQuad26November = 'Umrah Berkah By Lion Paket Quad';
  const packagePriceNlbQuad26November = 'Rp. 27.9 Juta';
  const hiddenNlbQuad26NovemberDate = '26 November 2025';

  const packageTitleNlbTriple26November = 'Umrah Berkah By Lion Paket Triple';
  const packagePriceNlbTriple26November = 'Rp. 30.4 Juta';
  const hiddenNlbTriple26NovemberDate = '26 November 2025';

  const packageTitleNlbDouble26November = 'Umrah Berkah By Lion Paket Double';
  const packagePriceNlbDouble26November = 'Rp. 31.4 Juta';
  const hiddenNlbDouble26NovemberDate = '26 November 2025';

  const packageTitleDbsatQuad3Desember =
    'Umrah Berkah Spesial Akhir Tahun Paket Quad';
  const packagePriceDbsatQuad3Desember = 'Rp. 29.5 Juta';
  const hiddenDbsatQuad3DesemberDate = '03 Desember 2025';

  const packageTitleDbsatTriple3Desember =
    'Umrah Berkah Spesial Akhir Tahun Paket Triple';
  const packagePriceDbsatTriple3Desember = 'Rp. 33 Juta';
  const hiddenDbsatTriple3DesemberDate = '03 Desember 2025';

  const packageTitleDbsatDouble3Desember =
    'Umrah Berkah Spesial Akhir Tahun Paket Double';
  const packagePriceDbsatDouble3Desember = 'Rp. 34 Juta';
  const hiddenDbsatDouble3DesemberDate = '03 Desember 2025';

  const packageTitleDbfsQuad24Desember =
    'Umrah Berkah Family Series Paket Quad';
  const packagePriceDbfsQuad24Desember = 'Rp. 33.5 Juta';
  const hiddenDbfsQuad24DesemberDate = '24 Desember 2025';

  const packageTitleDbfsTriple24Desember =
    'Umrah Berkah Family Series Paket Triple';
  const packagePriceDbfsTriple24Desember = 'Rp. 37 Juta';
  const hiddenDbfsTriple24DesemberDate = '24 Desember 2025';

  const packageTitleDbfsDouble24Desember =
    'Umrah Berkah Family Series Paket Double';
  const packagePriceDbfsDouble24Desember = 'Rp. 38 Juta';
  const hiddenDbfsDouble24DesemberDate = '24 Desember 2025';

  return (
    <div>
      {/* Paket Umroh Start */}
      <div className="container-xxl py-5" id="paket-umrah">
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title bg-white text-center text-primary px-3">
              Paket Perjalanan
            </h6>
            <h1 className="mb-5" style={{ color: 'black' }}>
              Paket Umrah: Januari - Desember 2025
            </h1>
          </div>

          {/* Tombol bulan tanpa container, menyatu antar kolom di bawah h1 */}
          {/* Pilih Bulan */}
          {showMonthButtons ? (
            <div className="d-flex justify-content-center gap-3 flex-wrap pb-4">
              {/* Kolom 1: Januari - Juni */}
              <div className="d-flex flex-wrap justify-content-center gap-3 mb-4 mb-md-0">
                {['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni'].map(
                  (month) => (
                    <button
                      key={month}
                      className="btn btn-outline-primary py-2 px-4"
                      style={{ fontWeight: 'bold' }}
                      onClick={() =>
                        !isMonthDisabled(month) && handleMonthSelect(month)
                      } // Hanya aktifkan klik untuk bulan yang tidak lewat
                      disabled={isMonthDisabled(month)}
                    >
                      {month}
                    </button>
                  )
                )}
              </div>

              {/* Kolom 2: Agustus - Desember */}
              <div className="d-flex flex-wrap justify-content-center gap-3 mb-4">
                {[
                  'Juli',
                  'Agustus',
                  'September',
                  'Oktober',
                  'November',
                  'Desember',
                ].map((month) => (
                  <button
                    key={month}
                    className="btn btn-outline-primary"
                    style={{ fontWeight: 'bold' }}
                    onClick={() =>
                      !isMonthDisabled(month) && handleMonthSelect(month)
                    } // Hanya aktifkan klik untuk bulan yang tidak lewat
                    disabled={isMonthDisabled(month)}
                  >
                    {month}
                  </button>
                ))}
              </div>
            </div>
          ) : (
            <div>
              <div className="d-flex justify-content-between align-items-center mb-4">
                {/* Tombol Kembali ke Pilihan Bulan di kiri */}
                <button
                  className="btn btn-outline-primary"
                  onClick={handleBack}
                  style={{ fontWeight: 'bold' }}
                >
                  Pilih Bulan
                </button>

                {/* Judul bulan yang dipilih, tampil seperti tombol tapi tidak bisa diklik */}
                {selectedMonth && (
                  <button
                    className="btn btn-primary"
                    style={{
                      fontWeight: 'bold',
                      pointerEvents: 'none',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {`${selectedMonth} 2025`}
                  </button>
                )}
              </div>

              {/* Jika ada tanggal yang relevan, tampilkan judul "Pilih Tanggal Yang Tersedia" seperti tombol */}
              {hasAvailableDates && (
                <div className="d-flex justify-content-center mb-4 stabilo1">
                  <button
                    className="btn btn-primary py-2 px-4"
                    style={{
                      fontWeight: 'bold',
                      pointerEvents: 'none',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      background: 'transparent', // Menghilangkan background
                      border: 'none', // Menghilangkan border
                      color: '#cfa936', // Warna teks yang sesuai dengan tombol (atau sesuai dengan warna tema)
                      fontSize: '18px', // Ukuran font yang sesuai
                      cursor: 'default', // Tidak ada efek pointer seperti tombol biasa
                      textTransform: 'uppercase', // Menjaga konsistensi huruf kapital
                    }}
                  >
                    Tanggal Keberangkatan Yang Tersedia
                  </button>
                </div>
              )}

              {/* Jika tidak ada tanggal, tampilkan pesan "Keberangkatan Tidak Tersedia" */}
              {!hasAvailableDates ? (
                <div className="d-flex justify-content-center align-items-center">
                  <div
                    className="alert alert-warning text-center"
                    style={{ width: '100%', textAlign: 'center' }}
                  >
                    Jadwal Keberangkatan Tidak Tersedia
                  </div>
                </div>
              ) : (
                // Pilih Tanggal hanya menampilkan tanggal relevan untuk bulan yang dipilih
                selectedMonth && (
                  <div className="d-flex justify-content-center gap-3 flex-wrap pb-4">
                    {monthDates[selectedMonth]?.map((date) => (
                      <button
                        key={date}
                        className="btn btn-outline-primary py-2 px-4"
                        onClick={() => handleDateSelect(date)}
                        style={{
                          backgroundColor:
                            selectedDate === date ? '#cfa936' : '',
                          color: selectedDate === date ? 'white' : '',
                        }}
                      >
                        {date}
                      </button>
                    ))}
                  </div>
                )
              )}
            </div>
          )}

          {/* Paket Umrah 1 Juli */}
          <>
            {selectedMonth === 'Juli' && selectedDate === 1 && (
              <div className="row g-4 justify-content-center">
                {/* Jika showJsbThaifDetailtrue, tampilkan detail Haji Furoda */}
                {showJsbThaifDetail && (
                  <div className="col-12 text-center">
                    <div className="h-100">
                      <img
                        className="img-fluid w-50 mb-4"
                        src="./assets/img/umroh/UMROH SUPER BERKAH SPESIAL MUHARAM PLUS THAIF 1 JUL 2025.jpg"
                        alt="Detail Umroh Super Berkah Spesial Muharam Plus Thaif 1 Juli"
                      />
                      <h3 style={{ color: 'black' }}>
                        Detail Paket Umroh Super Berkah Spesial Muharam Plus
                        Thaif
                      </h3>
                      <p class="stabilo1 sub-text">
                        <b>Berkah Muharram, Keberkahan Umroh! 🌙</b>
                      </p>
                      <p class="stabilo2 sub-text">
                        Jangan lewatkan kesempatan emas untuk menjalankan ibadah
                        Umroh dengan Paket Super Berkah Spesial Muharam Plus
                        Thaif! Daftar sekarang dan nikmati perjalanan spiritual
                        yang penuh makna. Tempat terbatas!"
                      </p>
                      <div className="row g-4 justify-content-center">
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          {/* Paket Quad Room */}
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Umroh Super Berkah Spesial Muharam Plus Thaif"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Quad
                                <br />
                                <span style={{ color: '#cfa936' }}>
                                  (26.9 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderJsbQuad1JuliForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderJsbQuad1JuliForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={handleSubmitOrderJsbQuad1Juli}
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Etihad</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Zuwar Al Bayt/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Zuwar Al Bayt/Setaraf Bintang
                                      3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Jawharat Ar Rasheed/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 9 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 9 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>

                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#jsbthaifpackagequadDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="jsbthaifpackagequadDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket :
                                </h5>
                                <p>Penjelasan detail paket quad</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Paket Triple */}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Umroh Super Berkah Spesial Muharam Plus Thaif"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Triple <br />
                                <span style={{ color: '#cfa936' }}>
                                  (29.4 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderJsbTriple1JuliForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderJsbTriple1JuliForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={handleSubmitOrderJsbTriple1Juli}
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Etihad</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Zuwar Al Bayt/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Zuwar Al Bayt/Setaraf Bintang
                                      3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Jawharat Ar Rasheed/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 9 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 9 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>
                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#jsbthaifpackagetripleDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="jsbthaifpackagetripleDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket :
                                </h5>
                                <p>Penjelasan detail paket</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Paket Double */}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Double"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Double <br />
                                <span className="text-gold exclusive">
                                  (30.4 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderJsbDouble1JuliForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderJsbDouble1JuliForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={handleSubmitOrderJsbDouble1Juli}
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Etihad</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Zuwar Al Bayt/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Zuwar Al Bayt/Setaraf Bintang
                                      3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Jawharat Ar Rasheed/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 9 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 9 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>

                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#jsbthaifpackagedoubleDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="jsbthaifpackagedoubleDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket Double:
                                </h5>
                                <p>Detail Paket Double</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <button
                          className="btn btn-primary"
                          onClick={handleBack}
                          style={{ fontWeight: 'bold' }}
                        >
                          Kembali Pilih Bulan
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
            {/* Paket Umrah 31 Juli*/}
            {selectedMonth === 'Juli' && selectedDate === 31 && (
              <div className="row g-4 justify-content-center">
                {!showJbsmDetail && !showJmsmDetail ? (
                  <>
                    {/* Paket Berkah Spesial Muharram 31 Juli*/}
                    <div
                      className="col-lg-6 col-md-6 col-sm-12 wow fadeInUp"
                      data-wow-delay="0.1s"
                    >
                      <div className="package-item h-100 d-flex flex-column">
                        <div className="overflow-hidden">
                          <img
                            className="img-fluid w-100"
                            src="./assets/img/umroh/UMROH BERKAH SPESIAL MUHARRAM 31 JULI 2025.jpg"
                            alt="Umrah Berkah Spesial Muharram"
                          />
                        </div>
                        <div className="d-flex border-bottom">
                          <small className="flex-fill text-center border-end py-2">
                            <i className="fa fa-calendar-alt text-primary me-2" />
                            9 Hari
                          </small>
                        </div>
                        <div className="text-center p-4 flex-grow-1 d-flex flex-column justify-content-between">
                          <div>
                            <span className="badge bg-primary mb-2">
                              Umrah Berkah Spesial Muharram
                            </span>
                            <h3 className="mb-0" style={{ color: 'black' }}>
                              Dimulai dari 29.5 Juta
                            </h3>
                            <p>
                              <i class="fa fa-building m-2"></i> Makkah: Maysan
                              Al Maqam/ Setaraf Bintang 3
                            </p>
                            <p>
                              <i class="fa fa-building m-2"></i> Madinah: Arjwan
                              Al Difayah/ Setaraf Bintang 3
                            </p>
                            <button
                              onClick={toggleContacts}
                              style={{
                                fontSize: '14px',
                                padding: '8px 16px',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease',
                              }}
                              className="contact-button"
                            >
                              <i
                                className="fas fa-phone-alt"
                                style={{ marginRight: '8px' }}
                              ></i>
                              Punya Pertanyaan ?
                            </button>

                            {showContacts && (
                              <div
                                style={{
                                  textAlign: 'center',
                                  fontSize: '18px',
                                  marginTop: '10px',
                                }}
                              >
                                <p>
                                  Rafi:{' '}
                                  <a
                                    href="https://wa.me/082136361688"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                                <p>
                                  Nanang:{' '}
                                  <a
                                    href="https://wa.me/081288596966"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                                <p>
                                  Call Center:{' '}
                                  <a
                                    href="https://wa.me/08118810491"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                              </div>
                            )}
                          </div>
                          <a
                            href="#"
                            className="btn btn-outline-primary mt-3"
                            onClick={handleJbsmClick}
                          >
                            Lihat Detail Paket
                          </a>
                        </div>
                      </div>
                    </div>

                    {/* Paket Umrah Mumtaaz Spesial Muharram 31 Juli*/}
                    <div
                      className="col-lg-6 col-md-6 col-sm-12 wow fadeInUp"
                      data-wow-delay="0.3s"
                    >
                      <div className="package-item h-100 d-flex flex-column">
                        <div className="overflow-hidden">
                          <img
                            className="img-fluid w-100"
                            src="./assets/img/umroh/UMROH MUMTAAZ SPESIAL MUHARRAM 31 JULI 2025.jpg"
                            alt="Mumtaaz Spesial Muharram "
                          />
                        </div>
                        <div className="d-flex border-bottom">
                          <small className="flex-fill text-center border-end py-2">
                            <i className="fa fa-calendar-alt text-primary me-2" />
                            9 Hari
                          </small>
                        </div>
                        <div className="text-center p-4 flex-grow-1 d-flex flex-column justify-content-between">
                          <div>
                            <span className="badge bg-primary mb-2">
                              Umrah Mumtaaz Spesial Muharram
                            </span>
                            <h3 className="mb-0" style={{ color: 'black' }}>
                              Dimulai dari Rp. 35 Juta
                            </h3>
                            <p>
                              <i class="fa fa-building m-2"></i>Makkah: Dorrar
                              Al Eiman/ Setaraf Bintang 5
                            </p>
                            <p>
                              <i class="fa fa-building m-2"></i>Madinah: Arjwan
                              Al Difayah/ Setaraf Bintang 3
                            </p>
                            <button
                              onClick={toggleContacts}
                              style={{
                                fontSize: '14px',
                                padding: '8px 16px',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease',
                              }}
                              className="contact-button"
                            >
                              <i
                                className="fas fa-phone-alt"
                                style={{ marginRight: '8px' }}
                              ></i>
                              Punya Pertanyaan ?
                            </button>

                            {showContacts && (
                              <div
                                style={{
                                  textAlign: 'center',
                                  fontSize: '18px',
                                  marginTop: '10px',
                                }}
                              >
                                <p>
                                  Rafi:{' '}
                                  <a
                                    href="https://wa.me/082136361688"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                                <p>
                                  Nanang:{' '}
                                  <a
                                    href="https://wa.me/081288596966"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                                <p>
                                  Call Center:{' '}
                                  <a
                                    href="https://wa.me/08118810491"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                              </div>
                            )}
                          </div>
                          <a
                            href="#"
                            className="btn btn-outline-primary mt-3"
                            onClick={handleJmsmClick}
                          >
                            Lihat Detail Paket
                          </a>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    {showJbsmDetail && (
                      // Paket Umrah Mumtaz
                      <div className="col-12 text-center">
                        <div className="h-100">
                          <img
                            className="img-fluid w-50 mb-4"
                            src="./assets/img/umroh/UMROH BERKAH SPESIAL MUHARRAM 31 JULI 2025.jpg"
                            alt="Detail Umroh Berkah Spesial Muharram"
                          />
                          <h3 style={{ color: 'black' }}>
                            Detail Paket Berkah Spesial Muharram
                          </h3>
                          <p class="stabilo1 sub-text">
                            Paket Berkah Spesial Muharram: Umroh dengan
                            Fasilitas Istimewa! 🕋
                          </p>
                          <p class="stabilo2 sub text">
                            Paket spesial dengan berbagai fasilitas premium kini
                            hadir untuk Anda. Cek detail lengkap Paket Berkah
                            Spesial Muharram dan raih keberkahan di tanah suci.
                            Jangan lewatkan kesempatan ini, tempat terbatas!"
                          </p>
                          <div className="row g-4 justify-content-center">
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              {/* Paket Quad Room */}
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Umrah Berkah Spesial Muharam"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Quad
                                    <br />
                                    <span style={{ color: '#cfa936' }}>
                                      (29.5 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={toggleOrderJbsmQuad31JuliForm}
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderJbsmQuad31JuliForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={handleSubmitOrderJbsmQuad31Juli}
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Saudia Airlines</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Maysan Al Maqam/Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Maysan Al Maqam/ Setaraf
                                          Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Arjwan Al Difayah/ Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Arjwan Al Difayah/
                                          Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#jbsmpackagequadDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="jbsmpackagequadDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket :
                                    </h5>
                                    <p>Penjelasan detail paket quad</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Paket Triple */}
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Umroh Berkah Spesial Muharam"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Triple <br />
                                    <span style={{ color: '#cfa936' }}>
                                      (32 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={toggleOrderJbsmTriple31JuliForm}
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderJbsmTriple31JuliForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderJbsmTriple31Juli
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}
                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Saudia Airlines</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Maysan Al Maqam/Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Maysan Al Maqam/ Setaraf
                                          Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Arjwan Al Difayah/ Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Arjwan Al Difayah/
                                          Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#jbsmpackagetripleDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="jbsmpackagetripleDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket :
                                    </h5>
                                    <p>Penjelasan detail paket</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Paket Double */}
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Double"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Double <br />
                                    <span className="text-gold exclusive">
                                      (33 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={toggleOrderJbsmDouble31JuliForm}
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderJbsmDouble31JuliForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderJbsmDouble31Juli
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Saudia Airlines</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Maysan Al Maqam/Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Maysan Al Maqam/ Setaraf
                                          Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Arjwan Al Difayah/ Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Arjwan Al Difayah/
                                          Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#jbsmpackagedoubleDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="jbsmpackagedoubleDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket Double:
                                    </h5>
                                    <p>Detail Paket Double</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <button
                              className="btn btn-primary"
                              onClick={handleBack}
                              style={{ fontWeight: 'bold' }}
                            >
                              Kembali Pilih Bulan
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    {showJmsmDetail && (
                      // Paket Umrah Mumtaz
                      <div className="col-12 text-center">
                        <div className="h-100">
                          <img
                            className="img-fluid w-50 mb-4"
                            src="./assets/img/umroh/UMROH MUMTAAZ SPESIAL MUHARRAM 31 JULI 2025.jpg"
                            alt="Detail Umroh Super Berkah Spesial Muharam Plus Thaif 1 Juli"
                          />
                          <h3 style={{ color: 'black' }}>
                            Detail Paket Umroh Super Berkah Spesial Muharam Plus
                            Thaif
                          </h3>
                          <p class="stabilo1 sub-text">
                            Umroh dengan Keistimewaan Spesial Muharam dan Thaif!
                            🌟
                          </p>
                          <p class="stabilo2 sub-text">
                            Jadikan perjalanan ibadah Anda lebih bermakna dengan
                            Paket Umroh Super Berkah. Daftar segera dan rasakan
                            pengalaman spiritual yang tak terlupakan.
                            Pendaftaran dibuka sekarang!"
                          </p>
                          <div className="row g-4 justify-content-center">
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              {/* Paket Quad Room */}
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Umroh Mumtaaz Spesial Muharram"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Quad
                                    <br />
                                    <span style={{ color: '#cfa936' }}>
                                      (35 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={toggleOrderJmsmQuad31JuliForm}
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderJmsmQuad31JuliForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={handleSubmitOrderJmsmQuad31Juli}
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Saudia Airlines</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Zuwar Al Bayt/Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Zuwar Al Bayt/Setaraf
                                          Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Jawharat Ar
                                          Rasheed/Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#jmsmpackagequadDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="jmsmpackagequadDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket :
                                    </h5>
                                    <p>Penjelasan detail paket quad</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Paket Triple */}
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Umroh Super Berkah Spesial Muharam Plus Thaif"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Triple <br />
                                    <span style={{ color: '#cfa936' }}>
                                      (37.5 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={toggleOrderJmsmTriple31JuliForm}
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderJmsmTriple31JuliForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderJmsmTriple31Juli
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Saudia Airlines</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Zuwar Al Bayt/Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Zuwar Al Bayt/Setaraf
                                          Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Jawharat Ar
                                          Rasheed/Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#jmsmpackagetripleDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="jmsmpackagetripleDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket :
                                    </h5>
                                    <p>Penjelasan detail paket</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Paket Double */}
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Double"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Double <br />
                                    <span className="text-gold exclusive">
                                      (38.5 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={toggleOrderJmsmDouble31JuliForm}
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderJmsmDouble31JuliForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderJmsmDouble31Juli
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Saudia Airlines</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Zuwar Al Bayt/Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Zuwar Al Bayt/Setaraf
                                          Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Jawharat Ar
                                          Rasheed/Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#jmsmpackagedoubleDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="jmsmpackagedoubleDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket Double:
                                    </h5>
                                    <p>Detail Paket Double</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <button
                              className="btn btn-primary"
                              onClick={handleBack}
                              style={{ fontWeight: 'bold' }}
                            >
                              Kembali Pilih Bulan
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            )}
          </>

          {/* Paket Umrah 8 Agustus */}
          <>
            {selectedMonth === 'Agustus' && selectedDate === 8 && (
              <div className="row g-4 justify-content-center">
                {!showAmtfsDetail && !showAmbfsDetail ? (
                  <>
                    {/* Paket Umrah Mahabbah FS dan Paket Umrah Mumtaaz FS*/}
                    <div
                      className="col-lg-6 col-md-6 col-sm-12 wow fadeInUp"
                      data-wow-delay="0.1s"
                    >
                      <div className="package-item h-100 d-flex flex-column">
                        <div className="overflow-hidden">
                          <img
                            className="img-fluid w-100"
                            src="./assets/img/umroh/UMROH MUMTAAZ FAMILY SERIES 8 AGUSTUS 2025.jpg"
                            alt="Paket Umrah Mumtaaz FS"
                          />
                        </div>
                        <div className="d-flex border-bottom">
                          <small className="flex-fill text-center border-end py-2">
                            <i className="fa fa-calendar-alt text-primary me-2" />
                            9 Hari
                          </small>
                        </div>
                        <div className="text-center p-4 flex-grow-1 d-flex flex-column justify-content-between">
                          <div>
                            <span className="badge bg-primary mb-2">
                              Umrah Mumtaaz Family Series
                            </span>
                            <h3 className="mb-0" style={{ color: 'black' }}>
                              Dimulai dari Rp. 36 Juta
                            </h3>
                            <p>
                              <i class="fa fa-building m-2"></i> Makkah: Dorrar
                              Al Eiman/ Setaraf Bintang 5
                            </p>
                            <p>
                              <i class="fa fa-building m-2"></i> Madinah: Arjwan
                              Al Difayah/ Setaraf Bintang 3
                            </p>
                            <button
                              onClick={toggleContacts}
                              style={{
                                fontSize: '14px',
                                padding: '8px 16px',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease',
                              }}
                              className="contact-button"
                            >
                              <i
                                className="fas fa-phone-alt"
                                style={{ marginRight: '8px' }}
                              ></i>
                              Punya Pertanyaan ?
                            </button>

                            {showContacts && (
                              <div
                                style={{
                                  textAlign: 'center',
                                  fontSize: '18px',
                                  marginTop: '10px',
                                }}
                              >
                                <p>
                                  Rafi:{' '}
                                  <a
                                    href="https://wa.me/082136361688"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                                <p>
                                  Nanang:{' '}
                                  <a
                                    href="https://wa.me/081288596966"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                                <p>
                                  Call Center:{' '}
                                  <a
                                    href="https://wa.me/08118810491"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                              </div>
                            )}
                          </div>
                          <a
                            href="#"
                            className="btn btn-outline-primary mt-3"
                            onClick={handleAmtfsClick}
                          >
                            Lihat Detail Paket
                          </a>
                        </div>
                      </div>
                    </div>

                    {/* Paket Umrah Mahabbah Family Series 8 Agustus*/}
                    <div
                      className="col-lg-6 col-md-6 col-sm-12 wow fadeInUp"
                      data-wow-delay="0.3s"
                    >
                      <div className="package-item h-100 d-flex flex-column">
                        <div className="overflow-hidden">
                          <img
                            className="img-fluid w-100"
                            src="./assets/img/umroh/UMROH MAHABBAH FAMILY SERIES 8 AGU 2025.jpg"
                            alt="Paket Umrah Mahabbah FS"
                          />
                        </div>
                        <div className="d-flex border-bottom">
                          <small className="flex-fill text-center border-end py-2">
                            <i className="fa fa-calendar-alt text-primary me-2" />
                            9 Hari
                          </small>
                        </div>
                        <div className="text-center p-4 flex-grow-1 d-flex flex-column justify-content-between">
                          <div>
                            <span className="badge bg-primary mb-2">
                              Umrah Mahabbah Family Series
                            </span>
                            <h3 className="mb-0" style={{ color: 'black' }}>
                              Dimulai dari Rp. 38 Juta
                            </h3>
                            <p>
                              <i class="fa fa-building m-2"></i>Makkah: Dorrar
                              Al Eiman/ Setaraf Bintang 5
                            </p>
                            <p>
                              <i class="fa fa-building m-2"></i>Madinah: Maden/
                              Setaraf Bintang 5
                            </p>
                            <button
                              onClick={toggleContacts}
                              style={{
                                fontSize: '14px',
                                padding: '8px 16px',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease',
                              }}
                              className="contact-button"
                            >
                              <i
                                className="fas fa-phone-alt"
                                style={{ marginRight: '8px' }}
                              ></i>
                              Punya Pertanyaan ?
                            </button>

                            {showContacts && (
                              <div
                                style={{
                                  textAlign: 'center',
                                  fontSize: '18px',
                                  marginTop: '10px',
                                }}
                              >
                                <p>
                                  Rafi:{' '}
                                  <a
                                    href="https://wa.me/082136361688"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                                <p>
                                  Nanang:{' '}
                                  <a
                                    href="https://wa.me/081288596966"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                                <p>
                                  Call Center:{' '}
                                  <a
                                    href="https://wa.me/08118810491"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                              </div>
                            )}
                          </div>
                          <a
                            href="#"
                            className="btn btn-outline-primary mt-3"
                            onClick={handleAmbfsClick}
                          >
                            Lihat Detail Paket
                          </a>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    {showAmtfsDetail && (
                      // Paket Umrah Mumtaz Family Series
                      <div className="col-12 text-center">
                        <div className="h-100">
                          <img
                            className="img-fluid w-50 mb-4"
                            src="./assets/img/umroh/UMROH MUMTAAZ FAMILY SERIES 8 AGUSTUS 2025.jpg"
                            alt="Detail Umroh Mumtaaz Family Series"
                          />
                          <h3 style={{ color: 'black' }}>
                            Detail Paket Mumtaaz Family Series
                          </h3>
                          <p class="stabilo1 sub-text">
                            Paket Mumtaaz Family Series: Perjalanan Umroh
                            Keluarga Penuh Keberkahan! 🌙
                          </p>
                          <p class="stabilo2 sub-text">
                            Ajak keluarga tercinta untuk merasakan pengalaman
                            spiritual bersama di Tanah Suci. Nikmati kenyamanan
                            dan fasilitas terbaik dengan Paket Mumtaaz Family
                            Series. Daftar sekarang dan ciptakan kenangan indah
                            bersama keluarga! Tempat terbatas!"
                          </p>
                          <div className="row g-4 justify-content-center">
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              {/* Paket Quad */}
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Umrah Berkah Spesial Muharam"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Quad
                                    <br />
                                    <span style={{ color: '#cfa936' }}>
                                      (36 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={toggleOrderAmtfsQuad8AgustusForm}
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderAmtfsQuad8AgustusForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderAmtfsQuad8Agustus
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Saudia Airlines</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Dorrar Al Eiman/Setaraf
                                          Bintang 5"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Dorrar Al Eiman/Setaraf
                                          Bintang 5
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Arjwan Al Difayah/
                                          Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#amtfspackagequadDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="amtfspackagequadDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket :
                                    </h5>
                                    <p>Penjelasan detail paket quad</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Paket Triple */}
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Umroh Berkah Spesial Muharam"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Triple <br />
                                    <span style={{ color: '#cfa936' }}>
                                      (38.5 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={toggleOrderAmtfsTriple8AgustusForm}
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderAmtfsTriple8AgustusForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderAmtfsTriple8Agustus
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Saudia Airlines</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Dorrar Al Eiman/Setaraf
                                          Bintang 5"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Dorrar Al Eiman/Setaraf
                                          Bintang 5
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Arjwan Al Difayah/ Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Arjwan Al Difayah/
                                          Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#amtfspackagetripleDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="amtfspackagetripleDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket :
                                    </h5>
                                    <p>Penjelasan detail paket</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Paket Double */}
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Double"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Double <br />
                                    <span className="text-gold exclusive">
                                      (39.5 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={toggleOrderAmtfsDouble8AgustusForm}
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderAmtfsDouble8AgustusForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderAmtfsDouble8Agustus
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Saudia Airlines</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Dorrar Al Eiman/Setaraf
                                          Bintang 5"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Dorrar Al Eiman/Setaraf
                                          Bintang 5
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Arjwan Al Difayah/ Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Arjwan Al Difayah/
                                          Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#amtfspackagedoubleDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="amtfspackagedoubleDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket Double:
                                    </h5>
                                    <p>Detail Paket Double</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <button
                              className="btn btn-primary"
                              onClick={handleBack}
                              style={{ fontWeight: 'bold' }}
                            >
                              Kembali Pilih Bulan
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    {showAmbfsDetail && (
                      // Paket Umrah Mahabbah Family Series
                      <div className="col-12 text-center">
                        <div className="h-100">
                          <img
                            className="img-fluid w-50 mb-4"
                            src="./assets/img/umroh/UMROH MAHABBAH FAMILY SERIES 8 AGU 2025.jpg"
                            alt="Detail Umroh Mahabbah Family Series"
                          />
                          <h3 style={{ color: 'black' }}>
                            Detail Paket Umroh Mahabbah Family Series
                          </h3>
                          <p class="stabilo1 sub-text">
                            Paket Umroh Mahabbah Family Series: Ibadah Bersama
                            Keluarga dengan Penuh Kasih Sayang! 🌙
                          </p>
                          <p class="stabilo2 sub-text">
                            Nikmati perjalanan umroh yang penuh berkah dan
                            kebersamaan dengan keluarga tercinta. Paket Umroh
                            Mahabbah Family Series hadir dengan fasilitas
                            terbaik untuk kenyamanan setiap anggota keluarga.
                            Daftar segera, tempat terbatas!"
                          </p>
                          <div className="row g-4 justify-content-center">
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              {/* Paket Quad */}
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Umroh Mumtaaz Spesial Muharram"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Quad
                                    <br />
                                    <span style={{ color: '#cfa936' }}>
                                      (38 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={toggleOrderAmbfsQuad8AgustusForm}
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderAmbfsQuad8AgustusForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderAmbfsQuad8Agustus
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Saudia Airlines</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Dorrar Al Eiman/Setaraf Bintang 5"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Dorrar Al Eiman/Setaraf
                                          Bintang 5
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Maden/ Setaraf Bintang 5"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Maden/ Setaraf Bintang 5
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#ambfspackagequadDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="ambfspackagequadDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket :
                                    </h5>
                                    <p>Penjelasan detail paket quad</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Paket Triple */}
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Umroh Super Berkah Spesial Muharam Plus Thaif"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Triple <br />
                                    <span style={{ color: '#cfa936' }}>
                                      (41.5 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={toggleOrderAmbfsTriple8AgustusForm}
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderAmbfsTriple8AgustusForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderAmbfsTriple8Agustus
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Saudia Airlines</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Dorrar Al Eiman/Setaraf Bintang 5"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Dorrar Al Eiman/Setaraf
                                          Bintang 5
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Maden/ Setaraf Bintang 5"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Maden/ Setaraf Bintang 5
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#ambfspackagetripleDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="ambfspackagetripleDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket :
                                    </h5>
                                    <p>Penjelasan detail paket</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Paket Double */}
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Double"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Double <br />
                                    <span className="text-gold exclusive">
                                      (42.5 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={toggleOrderAmbfsDouble8AgustusForm}
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderAmbfsDouble8AgustusForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderAmbfsDouble8Agustus
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Saudia Airlines</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Dorrar Al Eiman/Setaraf Bintang 5"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Dorrar Al Eiman/Setaraf
                                          Bintang 5
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Maden/ Setaraf Bintang 5"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Maden/ Setaraf Bintang 5
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#ambfspackagedoubleDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="ambfspackagedoubleDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket Double:
                                    </h5>
                                    <p>Detail Paket Double</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <button
                              className="btn btn-primary"
                              onClick={handleBack}
                              style={{ fontWeight: 'bold' }}
                            >
                              Kembali Pilih Bulan
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            )}

            {/* Paket Umrah 18 Agustus */}
            {selectedMonth === 'Agustus' && selectedDate === 18 && (
              <div className="row g-4 justify-content-center">
                {!showAsbthaifsmDetail && !showAsmthaifsmDetail ? (
                  <>
                    {/* Paket Umrah Syabab Berkah Thaif Spesial Muda-Mudi 18 Agustus*/}
                    <div
                      className="col-lg-6 col-md-6 col-sm-12 wow fadeInUp"
                      data-wow-delay="0.1s"
                    >
                      <div className="package-item h-100 d-flex flex-column">
                        <div className="overflow-hidden">
                          <img
                            className="img-fluid w-100"
                            src="./assets/img/umroh/AGUSTUS SYABAB BERKAH 18 AGU 2025 REVISI.jpg"
                            alt="Paket Umrah Syabab Berkah Spesial Muda-Mudi"
                          />
                        </div>
                        <div className="d-flex border-bottom">
                          <small className="flex-fill text-center border-end py-2">
                            <i className="fa fa-calendar-alt text-primary me-2" />
                            9 Hari
                          </small>
                        </div>
                        <div className="text-center p-4 flex-grow-1 d-flex flex-column justify-content-between">
                          <div>
                            <span className="badge bg-primary mb-2">
                              Umrah Syabab Berkah Thaif Spesial Muda-Mudi
                            </span>
                            <h3 className="mb-0" style={{ color: 'black' }}>
                              Dimulai dari Rp. 28.5 Juta
                            </h3>
                            <p>
                              <i class="fa fa-building m-2"></i> Makkah: Zuwar
                              Al Bayt/ Setaraf Bintang 3
                            </p>
                            <p>
                              <i class="fa fa-building m-2"></i> Madinah: Arjwan
                              Al Difayah/ Setaraf Bintang 3
                            </p>
                            <button
                              onClick={toggleContacts}
                              style={{
                                fontSize: '14px',
                                padding: '8px 16px',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease',
                              }}
                              className="contact-button"
                            >
                              <i
                                className="fas fa-phone-alt"
                                style={{ marginRight: '8px' }}
                              ></i>
                              Punya Pertanyaan ?
                            </button>

                            {showContacts && (
                              <div
                                style={{
                                  textAlign: 'center',
                                  fontSize: '18px',
                                  marginTop: '10px',
                                }}
                              >
                                <p>
                                  Rafi:{' '}
                                  <a
                                    href="https://wa.me/082136361688"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                                <p>
                                  Nanang:{' '}
                                  <a
                                    href="https://wa.me/081288596966"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                                <p>
                                  Call Center:{' '}
                                  <a
                                    href="https://wa.me/08118810491"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                              </div>
                            )}
                          </div>
                          <a
                            href="#"
                            className="btn btn-outline-primary mt-3"
                            onClick={handleAsbthaifsmClick}
                          >
                            Lihat Detail Paket
                          </a>
                        </div>
                      </div>
                    </div>

                    {/* Paket Umrah Syabab Mahabbah Thaif Spesial Muda-Mudi 18 Agustus*/}
                    <div
                      className="col-lg-6 col-md-6 col-sm-12 wow fadeInUp"
                      data-wow-delay="0.3s"
                    >
                      <div className="package-item h-100 d-flex flex-column">
                        <div className="overflow-hidden">
                          <img
                            className="img-fluid w-100"
                            src="./assets/img/umroh/AGUSTUS SYABAB MAHABBAH 18 AGU 2025 REVISI.jpg"
                            alt="Paket Umrah Syabab Mahabbah Thaif Spesial Muda-Mudi"
                          />
                        </div>
                        <div className="d-flex border-bottom">
                          <small className="flex-fill text-center border-end py-2">
                            <i className="fa fa-calendar-alt text-primary me-2" />
                            9 Hari
                          </small>
                        </div>
                        <div className="text-center p-4 flex-grow-1 d-flex flex-column justify-content-between">
                          <div>
                            <span className="badge bg-primary mb-2">
                              Umrah Syabab Mahabbah Thaif Spesial Muda-Mudi
                            </span>
                            <h3 className="mb-0" style={{ color: 'black' }}>
                              Dimulai dari Rp. 33.5 Juta
                            </h3>
                            <p>
                              <i class="fa fa-building m-2"></i>Makkah: Anjum/
                              Setaraf Bintang 5
                            </p>
                            <p>
                              <i class="fa fa-building m-2"></i>Madinah: Ruve/
                              Setaraf Bintang 5
                            </p>
                            <button
                              onClick={toggleContacts}
                              style={{
                                fontSize: '14px',
                                padding: '8px 16px',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease',
                              }}
                              className="contact-button"
                            >
                              <i
                                className="fas fa-phone-alt"
                                style={{ marginRight: '8px' }}
                              ></i>
                              Punya Pertanyaan ?
                            </button>

                            {showContacts && (
                              <div
                                style={{
                                  textAlign: 'center',
                                  fontSize: '18px',
                                  marginTop: '10px',
                                }}
                              >
                                <p>
                                  Rafi:{' '}
                                  <a
                                    href="https://wa.me/082136361688"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                                <p>
                                  Nanang:{' '}
                                  <a
                                    href="https://wa.me/081288596966"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                                <p>
                                  Call Center:{' '}
                                  <a
                                    href="https://wa.me/08118810491"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                              </div>
                            )}
                          </div>
                          <a
                            href="#"
                            className="btn btn-outline-primary mt-3"
                            onClick={handleAsmthaifsmClick}
                          >
                            Lihat Detail Paket
                          </a>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    {showAsbthaifsmDetail && (
                      // Paket Umrah Syabab Mahabbah Spesial Muda-Mudi
                      <div className="col-12 text-center">
                        <div className="h-100">
                          <img
                            className="img-fluid w-50 mb-4"
                            src="./assets/img/umroh/AGUSTUS SYABAB BERKAH 18 AGU 2025 REVISI.jpg"
                            alt="Detail Umrah Syabab Berkah Thaif Spesial Muda-Mudi"
                          />
                          <h3 style={{ color: 'black' }}>
                            Detail Umrah Syabab Berkah Thaif Spesial Muda-Mudi
                          </h3>
                          <p class="stabilo1 sub-text">
                            Umrah Syabab Berkah Thaif Spesial Muda-Mudi:
                            Spiritualitas dengan Semangat Anak Muda! 🌟
                          </p>
                          <p class="stabilo2 sub-text">
                            Ajak teman-temanmu untuk menjalani umrah bersama
                            dalam suasana penuh semangat dan keberkahan. Paket
                            ini dirancang khusus untuk muda-mudi yang ingin
                            merasakan pengalaman spiritual yang mendalam. Daftar
                            segera, kursi terbatas!"
                          </p>
                          <div className="row g-4 justify-content-center">
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              {/* Paket Quad */}
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Umrah Syabab Berkah Thaif Spesial Muda-Mudi"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Quad
                                    <br />
                                    <span style={{ color: '#cfa936' }}>
                                      (28.5 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={toggleOrderAsbthaifQuad18AgustusForm}
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderAsbthaifQuad18AgustusForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderAsbthaifQuad18Agustus
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Free Kereta Gantung"
                                      >
                                        <i
                                          className="fas fa-tram text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Kereta Gantung</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Etihad</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Zuwar Al Bayt/Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Zuwar Al Bayt/ Setaraf
                                          Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Arjwan Al Difayah/
                                          Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Arjwan Al Difayah/
                                          Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Free City Tour Thaif"
                                      >
                                        <i
                                         className="fas fa-city text-primary mb-2"
                                         style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Free City Tour Thaif
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#asbthaifsmpackagequadDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="asbthaifsmpackagequadDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket :
                                    </h5>
                                    <p>Penjelasan detail paket quad</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Paket Triple */}
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Umroh Syabab Berkah Thaif Spesial Muda-Mudi"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Triple <br />
                                    <span style={{ color: '#cfa936' }}>
                                      (32 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={
                                    toggleOrderAsbthaifTriple18AgustusForm
                                  }
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderAsbthaifTriple18AgustusForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderAsbthaifTriple18Agustus
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                       <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Free Kereta Gantung"
                                      >
                                        <i
                                          className="fas fa-tram text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Kereta Gantung</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Etihad</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Zuwar Al Bayt/ Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Zuwar Al Bayt/ Setaraf
                                          Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Arjwan Al Difayah/ Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Arjwan Al Difayah/
                                          Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                       <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Free City Tour Thaif"
                                      >
                                        <i
                                         className="fas fa-city text-primary mb-2"
                                         style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Free City Tour Thaif
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#asbthaifsmpackagetripleDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="asbthaifsmpackagetripleDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket :
                                    </h5>
                                    <p>Penjelasan detail paket</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Paket Double */}
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Double"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Double <br />
                                    <span className="text-gold exclusive">
                                      (33 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={
                                    toggleOrderAsbthaifDouble18AgustusForm
                                  }
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderAsbthaifDouble18AgustusForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderAsbthaifDouble18Agustus
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Free Kereta Gantung"
                                      >
                                        <i
                                          className="fas fa-tram  text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Kereta Gantung</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Etihad</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Zuwar Al Bayt/ Setaraf Bintang 3  
                                          "
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Zuwar Al Bayt/ Setaraf
                                          Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Arjwan Al Difayah/ Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Arjwan Al Difayah/
                                          Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                       <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Free City Tour Thaif"
                                      >
                                        <i
                                         className="fas fa-city text-primary mb-2"
                                         style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Free City Tour Thaif
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#asbthaifsmpackagedoubleDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="asbthaifsmpackagedoubleDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket Double:
                                    </h5>
                                    <p>Detail Paket Double</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <button
                              className="btn btn-primary"
                              onClick={handleBack}
                              style={{ fontWeight: 'bold' }}
                            >
                              Kembali Pilih Bulan
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    {showAsmthaifsmDetail && (
                      // Paket Umrah Syabab Mahabbah Spesial Muda-Mudi 18 Agustus
                      <div className="col-12 text-center">
                        <div className="h-100">
                          <img
                            className="img-fluid w-50 mb-4"
                            src="./assets/img/umroh/AGUSTUS SYABAB MAHABBAH 18 AGU 2025 REVISI.jpg"
                            alt="Umrah Syabab Mahabbah Spesial Muda-Mudi"
                          />
                          <h3 style={{ color: 'black' }}>
                            Detail Paket Umrah Syabab Mahabbah Spesial Muda-Mudi
                          </h3>
                          <p class="stabilo1 sub-text">
                            Umrah Syabab Berkah Thaif: Perjalanan Ibadah Penuh
                            Semangat untuk Muda-Mudi! 🌙
                          </p>
                          <p class="stabilo2 sub-text">
                            Dapatkan pengalaman umrah yang penuh berkah dengan
                            teman-teman sebayamu! Paket Umrah Syabab Berkah
                            Thaif Spesial Muda-Mudi hadir dengan fasilitas
                            terbaik untuk para pemuda yang ingin merasakan
                            spiritualitas Tanah Suci. Daftar segera, tempat
                            terbatas!"
                          </p>
                          <div className="row g-4 justify-content-center">
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              {/* Paket Quad */}
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Umrah Syabab Mahabbah Spesial Muda-Mudi"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Quad
                                    <br />
                                    <span style={{ color: '#cfa936' }}>
                                      (33.5 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={toggleOrderAsmthaifQuad18AgustusForm}
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderAsmthaifQuad18AgustusForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderAsmthaifQuad18Agustus
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Free Kereta Gantung"
                                      >
                                        <i
                                          className="fas fa-tram  text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Kereta Gantung</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Etihad</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Anjum/Setaraf Bintang 5"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Anjum/Setaraf Bintang 5
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Ruve/ Setaraf Bintang 5"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Ruve/ Setaraf Bintang 5
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                       <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Free City Tour Thaif"
                                      >
                                        <i
                                         className="fas fa-city text-primary mb-2"
                                         style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Free City Tour Thaif
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#asmthaifsmpackagequadDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="asmthaifsmpackagequadDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket :
                                    </h5>
                                    <p>Penjelasan detail paket quad</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Paket Triple */}
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Umroh Super Berkah Spesial Muharam Plus Thaif"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Triple <br />
                                    <span style={{ color: '#cfa936' }}>
                                      (36 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={
                                    toggleOrderAsmthaifTriple18AgustusForm
                                  }
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderAsmthaifTriple18AgustusForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderAsmthaifTriple18Agustus
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Free Kereta Gantung"
                                      >
                                        <i
                                          className="fas fa-tram  text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Kereta Gantung</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Etihad</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Anjum/Setaraf
                                          Bintang 5"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Anjum/Setaraf Bintang 5
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Ruve/ Setaraf Bintang 5"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Ruve/ Setaraf Bintang 5
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                       <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Free City Tour Thaif"
                                      >
                                        <i
                                         className="fas fa-city text-primary mb-2"
                                         style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Free City Tour Thaif
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#asmthaifsmpackagetripleDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="asmthaifsmpackagetripleDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket :
                                    </h5>
                                    <p>Penjelasan detail paket</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Paket Double */}
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Double"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Double <br />
                                    <span className="text-gold exclusive">
                                      (37 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={
                                    toggleOrderAsmthaifDouble18AgustusForm
                                  }
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderAsmthaifDouble18AgustusForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderAsmthaifDouble18Agustus
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Free Kereta Gantung"
                                      >
                                        <i
                                          className="fas fa-tram  text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Kereta Gantung</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Etihad</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Anjum/Setaraf Bintang 5"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Anjum/Setaraf Bintang 5
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Ruve/ Setaraf Bintang 5"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Ruve/ Setaraf Bintang 5
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Free City Tour Thaif"
                                      >
                                        <i
                                         className="fas fa-city text-primary mb-2"
                                         style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Free City Tour Thaif
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#asmthaifsmpackagedoubleDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="asmthaifsmpackagedoubleDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket Double:
                                    </h5>
                                    <p>Detail Paket Double</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <button
                              className="btn btn-primary"
                              onClick={handleBack}
                              style={{ fontWeight: 'bold' }}
                            >
                              Kembali Pilih Bulan
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            )}

            {/* Paket Umrah 27 Agustus */}
            {selectedMonth === 'Agustus' && selectedDate === 27 && (
              <div className="row g-4 justify-content-center">
                {showAbDetail && (
                  <div className="col-12 text-center">
                    <div className="h-100">
                      <img
                        className="img-fluid w-50 mb-4"
                        src="./assets/img/umroh/UMROH BERKAH 27 AGUSTUS 2025.jpg"
                        alt="Detail Umroh Berkah 27 Agustus"
                      />
                      <h3 style={{ color: 'black' }}>
                        Detail Paket Umroh Berkah
                      </h3>
                      <p class="stabilo1 sub-text">
                        Raih Keberkahan di Tanah Suci dengan Paket Umrah Berkah!
                        🕋
                      </p>
                      <p class="stabilo2 sub-text">
                        Paket Umrah Berkah menawarkan perjalanan ibadah yang
                        penuh makna dan kenyamanan. Dapatkan pengalaman
                        spiritual yang tidak terlupakan. Daftar sekarang, tempat
                        terbatas!"
                      </p>
                      <div className="row g-4 justify-content-center">
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          {/* Paket Quad Room */}
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Umrah Berkah 27 Agustus"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Quad
                                <br />
                                <span style={{ color: '#cfa936' }}>
                                  (29.5 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderAbQuad27AgustusForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderAbQuad27AgustusForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={handleSubmitOrderAbQuad27Agustus}
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Saudia Airlines</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Maysan Al Maqam/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Maysan Al Maqam/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Arjwan Al Difayah/ Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Arjwan Al Difayah/ Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 9 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 9 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>

                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#abpackagequadDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div id="abpackagequadDetails" className="collapse">
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket :
                                </h5>
                                <p>Penjelasan detail paket quad</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Paket Triple */}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Umroh Super Berkah Spesial Muharam Plus Thaif"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Triple <br />
                                <span style={{ color: '#cfa936' }}>
                                  (32 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderAbTriple27AgustusForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderAbTriple27AgustusForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={handleSubmitOrderAbTriple27Agustus}
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Saudia Airlines</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Maysan Al Maqam/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Maysan Al Maqam/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Arjwan Al Difayah/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Arjwan Al Difayah/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 9 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 9 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>
                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#absmpackagetripleDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="absmpackagetripleDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket :
                                </h5>
                                <p>Penjelasan detail paket</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Paket Double */}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Double"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Double <br />
                                <span className="text-gold exclusive">
                                  (33 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderAbDouble27AgustusForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderAbDouble27AgustusForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={handleSubmitOrderAbDouble27Agustus}
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Saudia Airlines</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Maysan Al Maqam/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Maysan Al Maqam/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Arjwan Al Difayah/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 9 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 9 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>

                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#absmpackagedoubleDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="absmpackagedoubleDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket Double:
                                </h5>
                                <p>Detail Paket Double</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <button
                          className="btn btn-primary"
                          onClick={handleBack}
                          style={{ fontWeight: 'bold' }}
                        >
                          Kembali Pilih Bulan
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </>
          {/* Paket Umrah 3 September 2025 */}
          <>
            {selectedMonth === 'September' && selectedDate === 3 && (
              <div className="row g-4 justify-content-center">
                {showSbDetail && (
                  <div className="col-12 text-center">
                    <div className="h-100">
                      <img
                        className="img-fluid w-50 mb-4"
                        src="./assets/img/umroh/UMROH BERKAH 2X JUMAT 3  SEP 2025.jpg"
                        alt="Detail Umroh Berkah 3 September 2025"
                      />
                      <h3 style={{ color: 'black' }}>
                        Detail Paket Umroh Berkah
                      </h3>
                      <p class="stabilo1 sub-text">
                        Raih Keberkahan di Tanah Suci dengan Paket Umrah Berkah!
                        🕋
                      </p>
                      <p class="stabilo2 sub-text">
                        Paket Umrah Berkah menawarkan perjalanan ibadah yang
                        penuh makna dan kenyamanan. Dapatkan pengalaman
                        spiritual yang tidak terlupakan. Daftar sekarang, tempat
                        terbatas!"
                      </p>
                      <div className="row g-4 justify-content-center">
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          {/* Paket Quad Room */}
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Umrah Berkah 27 Agustus"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Quad
                                <br />
                                <span style={{ color: '#cfa936' }}>
                                  (27.5 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderSbQuad3SeptemberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderSbQuad3SeptemberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={handleSubmitOrderSbQuad3September}
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Oman Air</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title=" Hotel Makkah Dyar Al Bayt/Setaraf
                                      Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Dyar Al Bayt/Setaraf Bintang
                                      3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Jawharat Al Rashid/ Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Jawharat Al Rashid/ Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 12 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 12 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>

                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#sbpackagequadDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div id="sbpackagequadDetails" className="collapse">
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket :
                                </h5>
                                <p>Penjelasan detail paket quad</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Paket Triple */}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Umroh Berkah"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Triple <br />
                                <span style={{ color: '#cfa936' }}>
                                  (30 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderSbTriple3SeptemberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderSbTriple3SeptemberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={handleSubmitOrderSbTriple3September}
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Oman Air</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Dyar Al Bayt/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Dyar Al Bayt/Setaraf Bintang
                                      3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Jawharat Al Rashid/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Jawharat Al Rashid/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 12 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 12 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>
                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#sbpackagetripleDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="sbpackagetripleDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket :
                                </h5>
                                <p>Penjelasan detail paket</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Paket Double */}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Double"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Double <br />
                                <span className="text-gold exclusive">
                                  (31 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderSbDouble3SeptemberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderSbDouble3SeptemberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={handleSubmitOrderSbDouble3September}
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Oman Air</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Dyar Al Bayt/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Dyar Al Bayt/Setaraf Bintang
                                      3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Jawharat Al Rashid/Setaraf
                                      Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Jawharat Al Rashid/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 12 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 12 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>

                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#sbpackagedoubleDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="sbpackagedoubleDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket Double:
                                </h5>
                                <p>Detail Paket Double</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <button
                          className="btn btn-primary"
                          onClick={handleBack}
                          style={{ fontWeight: 'bold' }}
                        >
                          Kembali Pilih Bulan
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Paket Umrah 10 September */}
            {selectedMonth === 'September' && selectedDate === 10 && (
              <div className="row g-4 justify-content-center">
                {!showSbThaifDetail && !showSmjThaifDetail ? (
                  <>
                    {/* Paket Umrah Berkah Plus Thaif*/}
                    <div
                      className="col-lg-6 col-md-6 col-sm-12 wow fadeInUp"
                      data-wow-delay="0.1s"
                    >
                      <div className="package-item h-100 d-flex flex-column">
                        <div className="overflow-hidden">
                          <img
                            className="img-fluid w-100"
                            src="./assets/img/umroh/UMROH BERKAH PLUS THAIF 10 SEP 2025.jpg"
                            alt="Paket Umrah Berkah Plus Thaif"
                          />
                        </div>
                        <div className="d-flex border-bottom">
                          <small className="flex-fill text-center border-end py-2">
                            <i className="fa fa-calendar-alt text-primary me-2" />
                            9 Hari
                          </small>
                        </div>
                        <div className="text-center p-4 flex-grow-1 d-flex flex-column justify-content-between">
                          <div>
                            <span className="badge bg-primary mb-2">
                              Umrah Berkah Plus Thaif
                            </span>
                            <h3 className="mb-0" style={{ color: 'black' }}>
                              Dimulai dari Rp. 28.5 Juta
                            </h3>
                            <p>
                              <i class="fa fa-building m-2"></i> Makkah: Zuwar
                              Al Bayt/ Setaraf Bintang 3
                            </p>
                            <p>
                              <i class="fa fa-building m-2"></i> Madinah:
                              Jawharat Al Rasheed/ Setaraf Bintang 3
                            </p>
                            <button
                              onClick={toggleContacts}
                              style={{
                                fontSize: '14px',
                                padding: '8px 16px',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease',
                              }}
                              className="contact-button"
                            >
                              <i
                                className="fas fa-phone-alt"
                                style={{ marginRight: '8px' }}
                              ></i>
                              Punya Pertanyaan ?
                            </button>

                            {showContacts && (
                              <div
                                style={{
                                  textAlign: 'center',
                                  fontSize: '18px',
                                  marginTop: '10px',
                                }}
                              >
                                <p>
                                  Rafi:{' '}
                                  <a
                                    href="https://wa.me/082136361688"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                                <p>
                                  Nanang:{' '}
                                  <a
                                    href="https://wa.me/081288596966"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                                <p>
                                  Call Center:{' '}
                                  <a
                                    href="https://wa.me/08118810491"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                              </div>
                            )}
                          </div>
                          <a
                            href="#"
                            className="btn btn-outline-primary mt-3"
                            onClick={handleSbThaifClick}
                          >
                            Lihat Detail Paket
                          </a>
                        </div>
                      </div>
                    </div>

                    {/* Paket Umrah Munajat Plus Thaif*/}
                    <div
                      className="col-lg-6 col-md-6 col-sm-12 wow fadeInUp"
                      data-wow-delay="0.3s"
                    >
                      <div className="package-item h-100 d-flex flex-column">
                        <div className="overflow-hidden">
                          <img
                            className="img-fluid w-100"
                            src="./assets/img/umroh/SEPTEMBER MUNAJAT PLUS THAIF 10 SEP 2025.jpg"
                            alt="Paket Umrah Munajat Plus Thaif"
                          />
                        </div>
                        <div className="d-flex border-bottom">
                          <small className="flex-fill text-center border-end py-2">
                            <i className="fa fa-calendar-alt text-primary me-2" />
                            9 Hari
                          </small>
                        </div>
                        <div className="text-center p-4 flex-grow-1 d-flex flex-column justify-content-between">
                          <div>
                            <span className="badge bg-primary mb-2">
                              Umrah Munajat Plus Thaif
                            </span>
                            <h3 className="mb-0" style={{ color: 'black' }}>
                              Dimulai dari Rp. 32.9 Juta
                            </h3>
                            <p>
                              <i class="fa fa-building m-2"></i>Makkah: Rayyana
                              / Setaraf Bintang 4
                            </p>
                            <p>
                              <i class="fa fa-building m-2"></i>Madinah: Grand
                              Plaza/ Setaraf Bintang 4
                            </p>
                            <button
                              onClick={toggleContacts}
                              style={{
                                fontSize: '14px',
                                padding: '8px 16px',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease',
                              }}
                              className="contact-button"
                            >
                              <i
                                className="fas fa-phone-alt"
                                style={{ marginRight: '8px' }}
                              ></i>
                              Punya Pertanyaan ?
                            </button>

                            {showContacts && (
                              <div
                                style={{
                                  textAlign: 'center',
                                  fontSize: '18px',
                                  marginTop: '10px',
                                }}
                              >
                                <p>
                                  Rafi:{' '}
                                  <a
                                    href="https://wa.me/082136361688"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                                <p>
                                  Nanang:{' '}
                                  <a
                                    href="https://wa.me/081288596966"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                                <p>
                                  Call Center:{' '}
                                  <a
                                    href="https://wa.me/08118810491"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                              </div>
                            )}
                          </div>
                          <a
                            href="#"
                            className="btn btn-outline-primary mt-3"
                            onClick={handleSmjThaifClick}
                          >
                            Lihat Detail Paket
                          </a>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    {showSbThaifDetail && (
                      // Paket Umrah September Berkah Plus Thaif
                      <div className="col-12 text-center">
                        <div className="h-100">
                          <img
                            className="img-fluid w-50 mb-4"
                            src="./assets/img/umroh/UMROH BERKAH PLUS THAIF 10 SEP 2025.jpg"
                            alt="Detail Umroh Berkah Plus Thaif"
                          />
                          <h3 style={{ color: 'black' }}>
                            Detail Umroh Berkah Plus Thaif
                          </h3>
                          <p class="stabilo1 sub-text">
                            Paket Berkah Plus Thaif: Ibadah Plus Keindahan Thaif
                            yang Memukau! 🌟
                          </p>
                          <p class="stabilo2 sub-text">
                            Ajak keluarga atau teman-teman untuk merasakan
                            ibadah umroh dengan tambahan keindahan dan kedamaian
                            Thaif. Paket Berkah Plus Thaif memberikan pengalaman
                            spiritual dan wisata yang luar biasa. Tempat
                            terbatas, segera daftar!"
                          </p>
                          <div className="row g-4 justify-content-center">
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              {/* Paket Quad */}
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Umrah Berkah Plus Thaif"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Quad
                                    <br />
                                    <span style={{ color: '#cfa936' }}>
                                      (28.5 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={
                                    toggleOrderSbThaifQuad10SeptemberForm
                                  }
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderSbThaifQuad10SeptemberForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderSbThaifQuad10September
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Free Kereta Gantung"
                                      >
                                        <i
                                          className="fas fa-tram  text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Kereta Gantung</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Etihad</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Zuwar Al Bayt/Setaraf
                                          Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Zuwar Al Bayt/Setaraf
                                          Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Jawharat Al Rasheed/ Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Jawharat Al Rasheed/
                                          Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#sbthaifpackagequadDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="sbthaifpackagequadDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket :
                                    </h5>
                                    <p>Penjelasan detail paket quad</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Paket Triple */}
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Umroh Berkah Spesial Muharam"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Triple <br />
                                    <span style={{ color: '#cfa936' }}>
                                      (31 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={
                                    toggleOrderSbThaifTriple10SeptemberForm
                                  }
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderSbThaifTriple10SeptemberForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderSbThaifTriple10September
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Free Kereta Gantung"
                                      >
                                        <i
                                          className="fas fa-tram  text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Kereta Gantung</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Etihad</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Zuwar Al Bayt/Setaraf
                                          Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Zuwar Al Bayt/Setaraf
                                          Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Jawharat Al Rasheed/ Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Jawharat Al Rasheed/
                                          Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                       <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Free City Tour Thaif"
                                      >
                                        <i
                                         className="fas fa-city text-primary mb-2"
                                         style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Free City Tour Thaif
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#sbthaifpackagetripleDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="sbthaifpackagetripleDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket :
                                    </h5>
                                    <p>Penjelasan detail paket</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Paket Double */}
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Double"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Double <br />
                                    <span className="text-gold exclusive">
                                      (32 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={
                                    toggleOrderSbThaifDouble10SeptemberForm
                                  }
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderSbThaifDouble10SeptemberForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderSbThaifDouble10September
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Free Kereta Gantung"
                                      >
                                        <i
                                          className="fas fa-tram  text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Kereta Gantung</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Etihad</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Zuwar Al Bayt/Setaraf
                                          Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Zuwar Al Bayt/Setaraf
                                          Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Jawharat Al Rasheed/ Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Jawharat Al Rasheed/
                                          Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                       <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Free City Tour Thaif"
                                      >
                                        <i
                                         className="fas fa-city text-primary mb-2"
                                         style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Free City Tour Thaif
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#sbthaifpackagedoubleDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="sbthaifpackagedoubleDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket Double:
                                    </h5>
                                    <p>Detail Paket Double</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <button
                              className="btn btn-primary"
                              onClick={handleBack}
                              style={{ fontWeight: 'bold' }}
                            >
                              Kembali Pilih Bulan
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    {showSmjThaifDetail && (
                      // Paket Umrah Munajat Plus Thaif
                      <div className="col-12 text-center">
                        <div className="h-100">
                          <img
                            className="img-fluid w-50 mb-4"
                            src="./assets/img/umroh/SEPTEMBER MUNAJAT PLUS THAIF 10 SEP 2025.jpg"
                            alt="Detail Umrah Munajat Plus Thaif"
                          />
                          <h3 style={{ color: 'black' }}>
                            Detail Paket Umrah Munajat Plus Thaif
                          </h3>
                          <p class="stabilo1 sub-text">
                            Paket Umrah Munajat Plus Thaif: Perjalanan Ibadah
                            dengan Doa Penuh Keberkahan! 🌙
                          </p>
                          <p class="stabilo2 sub-text">
                            Nikmati ibadah umrah yang penuh berkah dengan
                            tambahan doa dan munajat, serta kunjungan ke Thaif
                            yang indah. Paket ini dirancang untuk membawa Anda
                            lebih dekat kepada Allah. Daftar sekarang, tempat
                            terbatas!"
                          </p>
                          <div className="row g-4 justify-content-center">
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              {/* Paket Quad */}
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Umroh Mumtaaz Spesial Muharram"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Quad
                                    <br />
                                    <span style={{ color: '#cfa936' }}>
                                      (32.9 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={
                                    toggleOrderSmjThaifQuad10SeptemberForm
                                  }
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderSmjThaifQuad10SeptemberForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderSmjThaifQuad10September
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Free Kereta Gantung"
                                      >
                                        <i
                                          className="fas fa-tram  text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Kereta Gantung</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Etihad</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Rayyana/Setaraf Bintang 4"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Rayyana/Setaraf Bintang 4
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Grand Plaza/ Setaraf Bintang 4"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Grand Plaza/ Setaraf
                                          Bintang 4
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Free City Tour Thaif"
                                      >
                                        <i
                                         className="fas fa-city text-primary mb-2"
                                         style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Free City Tour Thaif
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#smjthaifpackagequadDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="smjthaifpackagequadDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket :
                                    </h5>
                                    <p>Penjelasan detail paket quad</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Paket Triple */}
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Umroh Super Berkah Spesial Muharam Plus Thaif"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Triple <br />
                                    <span style={{ color: '#cfa936' }}>
                                      (35.4 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={
                                    toggleOrderSmjThaifTriple10SeptemberForm
                                  }
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderSmjThaifTriple10SeptemberForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderSmjThaifTriple10September
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Free Kereta Gantung"
                                      >
                                        <i
                                          className="fas fa-tram  text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Kereta Gantung</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Etihad</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Rayyana/Setaraf Bintang 4"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Rayyana/Setaraf Bintang 4
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Grand Plaza/ Setaraf Bintang 4"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Grand Plaza/ Setaraf
                                          Bintang 4
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Free City Tour Thaif"
                                      >
                                        <i
                                         className="fas fa-city text-primary mb-2"
                                         style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Free City Tour Thaif
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#smjthaifpackagetripleDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="smjthaifpackagetripleDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket :
                                    </h5>
                                    <p>Penjelasan detail paket</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Paket Double */}
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Double"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Double <br />
                                    <span className="text-gold exclusive">
                                      (36.4 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={
                                    toggleOrderSmjThaifDouble10SeptemberForm
                                  }
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderSmjThaifDouble10SeptemberForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderSmjThaifDouble10September
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Free Kereta Gantung"
                                      >
                                        <i
                                          className="fas fa-tram  text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Kereta Gantung</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Etihad</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Rayyana/Setaraf
                                          Bintang 4"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Rayyana/Setaraf Bintang 4
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Grand Plaza/ Setaraf Bintang 4"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Grand Plaza/ Setaraf
                                          Bintang 4
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Free City Tour Thaif"
                                      >
                                        <i
                                         className="fas fa-city text-primary mb-2"
                                         style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Free City Tour Thaif
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#smjthaifpackagedoubleDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="smjthaifpackagedoubleDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket Double:
                                    </h5>
                                    <p>Detail Paket Double</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <button
                              className="btn btn-primary"
                              onClick={handleBack}
                              style={{ fontWeight: 'bold' }}
                            >
                              Kembali Pilih Bulan
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            )}

            {/* Paket Umrah 15 September */}
            {selectedMonth === 'September' && selectedDate === 15 && (
              <div className="row g-4 justify-content-center">
                {!showSbLimabelasDetail && !showSmtDetail ? (
                  <>
                    {/* Paket Umrah Berkah 15*/}
                    <div
                      className="col-lg-6 col-md-6 col-sm-12 wow fadeInUp"
                      data-wow-delay="0.1s"
                    >
                      <div className="package-item h-100 d-flex flex-column">
                        <div className="overflow-hidden">
                          <img
                            className="img-fluid w-100"
                            src="./assets/img/umroh/UMROH BERKAH 15 SEPTEMBER 2025 AGEN.jpg"
                            alt="Paket Umrah Berkah 15 September"
                          />
                        </div>
                        <div className="d-flex border-bottom">
                          <small className="flex-fill text-center border-end py-2">
                            <i className="fa fa-calendar-alt text-primary me-2" />
                            9 Hari
                          </small>
                        </div>
                        <div className="text-center p-4 flex-grow-1 d-flex flex-column justify-content-between">
                          <div>
                            <span className="badge bg-primary mb-2">
                              Umrah Berkah
                            </span>
                            <h3 className="mb-0" style={{ color: 'black' }}>
                              Dimulai dari Rp. 29.5 Juta
                            </h3>
                            <p>
                              <i class="fa fa-building m-2"></i> Makkah: Maysan
                              Al Maqam/ Setaraf Bintang 3
                            </p>
                            <p>
                              <i class="fa fa-building m-2"></i> Madinah: Arjwan
                              Al Difayah/ Setaraf Bintang 3
                            </p>
                            <button
                              onClick={toggleContacts}
                              style={{
                                fontSize: '14px',
                                padding: '8px 16px',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease',
                              }}
                              className="contact-button"
                            >
                              <i
                                className="fas fa-phone-alt"
                                style={{ marginRight: '8px' }}
                              ></i>
                              Punya Pertanyaan ?
                            </button>

                            {showContacts && (
                              <div
                                style={{
                                  textAlign: 'center',
                                  fontSize: '18px',
                                  marginTop: '10px',
                                }}
                              >
                                <p>
                                  Rafi:{' '}
                                  <a
                                    href="https://wa.me/082136361688"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                                <p>
                                  Nanang:{' '}
                                  <a
                                    href="https://wa.me/081288596966"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                                <p>
                                  Call Center:{' '}
                                  <a
                                    href="https://wa.me/08118810491"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                              </div>
                            )}
                          </div>
                          <a
                            href="#"
                            className="btn btn-outline-primary mt-3"
                            onClick={handleSbLimaBelasClick}
                          >
                            Lihat Detail Paket
                          </a>
                        </div>
                      </div>
                    </div>

                    {/* Paket Umrah Mumtaaz*/}
                    <div
                      className="col-lg-6 col-md-6 col-sm-12 wow fadeInUp"
                      data-wow-delay="0.3s"
                    >
                      <div className="package-item h-100 d-flex flex-column">
                        <div className="overflow-hidden">
                          <img
                            className="img-fluid w-100"
                            src="./assets/img/umroh/UMROH MUMTAAZ 15 SEP 2025.jpg"
                            alt="Paket Umrah Mumtaaz"
                          />
                        </div>
                        <div className="d-flex border-bottom">
                          <small className="flex-fill text-center border-end py-2">
                            <i className="fa fa-calendar-alt text-primary me-2" />
                            9 Hari
                          </small>
                        </div>
                        <div className="text-center p-4 flex-grow-1 d-flex flex-column justify-content-between">
                          <div>
                            <span className="badge bg-primary mb-2">
                              Umrah Mumtaaz
                            </span>
                            <h3 className="mb-0" style={{ color: 'black' }}>
                              Dimulai dari Rp. 36 Juta
                            </h3>
                            <p>
                              <i class="fa fa-building m-2"></i>Makkah: Dorrar
                              Al Eiman / Setaraf Bintang 5
                            </p>
                            <p>
                              <i class="fa fa-building m-2"></i>Madinah: Arjwan
                              Al Difayah/ Setaraf Bintang 3
                            </p>
                            <button
                              onClick={toggleContacts}
                              style={{
                                fontSize: '14px',
                                padding: '8px 16px',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease',
                              }}
                              className="contact-button"
                            >
                              <i
                                className="fas fa-phone-alt"
                                style={{ marginRight: '8px' }}
                              ></i>
                              Punya Pertanyaan ?
                            </button>

                            {showContacts && (
                              <div
                                style={{
                                  textAlign: 'center',
                                  fontSize: '18px',
                                  marginTop: '10px',
                                }}
                              >
                                <p>
                                  Rafi:{' '}
                                  <a
                                    href="https://wa.me/082136361688"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                                <p>
                                  Nanang:{' '}
                                  <a
                                    href="https://wa.me/081288596966"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                                <p>
                                  Call Center:{' '}
                                  <a
                                    href="https://wa.me/08118810491"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                              </div>
                            )}
                          </div>
                          <a
                            href="#"
                            className="btn btn-outline-primary mt-3"
                            onClick={handleSmtClick}
                          >
                            Lihat Detail Paket
                          </a>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    {showSbLimabelasDetail && (
                      // Paket Umrah Berkah 15 September
                      <div className="col-12 text-center">
                        <div className="h-100">
                          <img
                            className="img-fluid w-50 mb-4"
                            src="./assets/img/umroh/UMROH BERKAH 15 SEPTEMBER 2025 AGEN.jpg"
                            alt="Detail Umroh Berkah"
                          />
                          <h3 style={{ color: 'black' }}>
                            Detail Umroh Berkah
                          </h3>
                          <p class="stabilo1 sub-text">
                            Paket Umrah Berkah: Ibadah Penuh Berkah dengan
                            Fasilitas Terbaik! 🌟
                          </p>
                          <p class="stabilo2 sub-text">
                            Siapkan diri Anda untuk perjalanan spiritual penuh
                            keberkahan dengan Paket Umrah Berkah. Dengan
                            fasilitas terbaik dan pelayanan istimewa, perjalanan
                            ini akan menjadi kenangan tak terlupakan. Segera
                            daftar, tempat terbatas!"
                          </p>
                          <div className="row g-4 justify-content-center">
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              {/* Paket Quad */}
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Umrah Berkah Plus Thaif"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Quad
                                    <br />
                                    <span style={{ color: '#cfa936' }}>
                                      (29.5 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={
                                    toggleOrderSbLimabelasQuad15SeptemberForm
                                  }
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderSbLimabelasQuad15SeptemberForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderSbLimabelasQuad15September
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Saudia Airlines</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Maysan Al Maqam/Setaraf
                                          Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Maysan Al Maqam/Setaraf
                                          Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Arjwan Al Difayah/ Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Arjwan Al Difayah/
                                          Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#sblimabelaspackagequadDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="sblimabelaspackagequadDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket :
                                    </h5>
                                    <p>Penjelasan detail paket quad</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Paket Triple */}
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Umroh Berkah Spesial Muharam"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Triple <br />
                                    <span style={{ color: '#cfa936' }}>
                                      (32 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={
                                    toggleOrderSbLimabelasTriple15SeptemberForm
                                  }
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderSbLimabelasTriple15SeptemberForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderSbLimabelasTriple15September
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Saudia Airlines</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Maysan Al Maqam/Setaraf
                                          Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Maysan Al Maqam/Setaraf
                                          Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Arjwan Al Difayah/ Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Arjwan Al Difayah/
                                          Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#sblimabelaspackagetripleDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="sblimabelaspackagetripleDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket :
                                    </h5>
                                    <p>Penjelasan detail paket</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Paket Double */}
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Double"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Double <br />
                                    <span className="text-gold exclusive">
                                      (33 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={
                                    toggleOrderSbLimabelasDouble15SeptemberForm
                                  }
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderSbLimabelasDouble15SeptemberForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderSbLimabelasDouble15September
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Saudia Airlines</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Maysan Al Maqam/Setaraf
                                          Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Maysan Al Maqam/Setaraf
                                          Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Arjwan Al Difayah/ Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Arjwan Al Difayah/
                                          Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#sblimabelaspackagedoubleDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="sblimabelaspackagedoubleDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket Double:
                                    </h5>
                                    <p>Detail Paket Double</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <button
                              className="btn btn-primary"
                              onClick={handleBack}
                              style={{ fontWeight: 'bold' }}
                            >
                              Kembali Pilih Bulan
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    {showSmtDetail && (
                      // Paket Umrah Mumtaaz
                      <div className="col-12 text-center">
                        <div className="h-100">
                          <img
                            className="img-fluid w-50 mb-4"
                            src="./assets/img/umroh/UMROH MUMTAAZ 15 SEP 2025.jpg"
                            alt="Detail Umrah Mumtaaz"
                          />
                          <h3 style={{ color: 'black' }}>
                            Detail Paket Umrah Mumtaaz
                          </h3>
                          <p class="stabilo1 sub-text">
                            Paket Umrah Mumtaaz: Perjalanan Ibadah yang Penuh
                            Keistimewaan! 🌙
                          </p>
                          <p class="stabilo2 sub-text">
                            Nikmati perjalanan umrah dengan layanan dan
                            fasilitas terbaik di Paket Umrah Mumtaaz. Dapatkan
                            pengalaman spiritual yang tak terlupakan dengan
                            kenyamanan yang sempurna. Daftar sekarang, tempat
                            terbatas!"
                          </p>
                          <div className="row g-4 justify-content-center">
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              {/* Paket Quad */}
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Umroh Mumtaaz Spesial Muharram"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Quad
                                    <br />
                                    <span style={{ color: '#cfa936' }}>
                                      (36 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={toggleOrderSmtQuad15SeptemberForm}
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderSmtQuad15SeptemberForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderSmtQuad15September
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Saudia Airlines</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Dorrar Al Eiman/Setaraf Bintang 5"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Dorrar Al Eiman/Setaraf
                                          Bintang 5
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Arjwan Al Difayah/ Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Arjwan Al Difayah/
                                          Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#smjthaifpackagequadDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="smjthaifpackagequadDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket :
                                    </h5>
                                    <p>Penjelasan detail paket quad</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Paket Triple */}
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Umroh Super Berkah Spesial Muharam Plus Thaif"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Triple <br />
                                    <span style={{ color: '#cfa936' }}>
                                      (38.5 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={toggleOrderSmtTriple15SeptemberForm}
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderSmtTriple15SeptemberForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderSmtTriple15September
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Saudia Airlines</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Dorrar Al Eiman/Setaraf Bintang 5"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Dorrar Al Eiman/Setaraf
                                          Bintang 5
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Arjwan Al Difayah/ Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Arjwan Al Difayah/
                                          Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#smjthaifpackagetripleDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="smjthaifpackagetripleDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket :
                                    </h5>
                                    <p>Penjelasan detail paket</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Paket Double */}
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Double"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Double <br />
                                    <span className="text-gold exclusive">
                                      (39.5 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={toggleOrderSmtDouble15SeptemberForm}
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderSmtDouble15SeptemberForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderSmtDouble15September
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Saudia Airlines</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Dorrar Al Eiman/Setaraf
                                          Bintang 5"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Dorrar Al Eiman/Setaraf
                                          Bintang 5
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Arjwan Al Difayah/ Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Arjwan Al Difayah/
                                          Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 9 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 9 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#smjthaifpackagedoubleDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="smjthaifpackagedoubleDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket Double:
                                    </h5>
                                    <p>Detail Paket Double</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <button
                              className="btn btn-primary"
                              onClick={handleBack}
                              style={{ fontWeight: 'bold' }}
                            >
                              Kembali Pilih Bulan
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            )}

            {/* Paket Umrah 24 September */}
            {selectedMonth === 'September' && selectedDate === 24 && (
              <div className="row g-4 justify-content-center">
                {showSpbDetail && (
                  <div className="col-12 text-center">
                    <div className="h-100">
                      <img
                        className="img-fluid w-50 mb-4"
                        src="./assets/img/umroh/UMROH PLUS DUBAI 24 SEP 2025 REVISI.jpg"
                        alt="Detail Umroh Plus Dubai"
                      />
                      <h3 style={{ color: 'black' }}>
                        Detail Paket Umrah Plus Dubai
                      </h3>
                      <p class="stabilo1 sub-text">
                        Paket Umrah Plus Dubai: Perjalanan Ibadah dan Wisata
                        Eksklusif! 🌙
                      </p>
                      <p class="stabilo2 sub-text">
                        Nikmati perjalanan spiritual penuh berkah dengan
                        tambahan wisata eksklusif ke Dubai! Dapatkan pengalaman
                        ibadah umrah yang luar biasa, ditambah kunjungan ke kota
                        futuristik Dubai. Daftar segera, tempat terbatas!"
                      </p>
                      <div className="row g-4 justify-content-center">
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          {/* Paket Quad Room */}
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Umrah Berkah 27 Agustus"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Quad
                                <br />
                                <span style={{ color: '#cfa936' }}>
                                  (33.9 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderSpbQuad24SeptemberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderSpbQuad24SeptemberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={handleSubmitOrderSpbQuad24September}
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Emirates</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Dorrar Al Eiman/Setaraf Bintang 5"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Dorrar Al Eiman/Setaraf
                                      Bintang 5
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Arjwan Al Difayah/ Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Arjwan Al Difayah/ Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 10 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 10 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                     className="feature-item"
                                     data-bs-toggle="tooltip"
                                     data-bs-placement="top"
                                     title="Free City Tour Dubai"
                                  >
                                    <i
                                        className="fas fa-city text-primary mb-2"
                                        style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Free City Tour Dubai
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>

                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#spbpackagequadDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="spbpackagequadDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket :
                                </h5>
                                <p>Penjelasan detail paket quad</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Paket Triple */}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Umroh Plus Dubai"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Triple <br />
                                <span style={{ color: '#cfa936' }}>
                                  (36.4 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderSpbTriple24SeptemberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderSpbTriple24SeptemberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={
                                    handleSubmitOrderSpbTriple24September
                                  }
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Emirates</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Dorrar Al Eiman/Setaraf Bintang 5"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Dorrar Al Eiman/Setaraf
                                      Bintang 5
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Arjwan Al Difayah/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Arjwan Al Difayah/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 10 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 10 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                     className="feature-item"
                                     data-bs-toggle="tooltip"
                                     data-bs-placement="top"
                                     title="Free City Tour Dubai"
                                  >
                                    <i
                                        className="fas fa-city text-primary mb-2"
                                        style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Free City Tour Dubai
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>
                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#spbpackagetripleDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="spbpackagetripleDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket :
                                </h5>
                                <p>Penjelasan detail paket</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Paket Double */}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Double"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Double <br />
                                <span className="text-gold exclusive">
                                  (37.4 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderSpbDouble24SeptemberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderSpbDouble24SeptemberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={
                                    handleSubmitOrderSpbDouble24September
                                  }
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Emirates</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Dorrar Al Eiman/Setaraf Bintang 5"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Dorrar Al Eiman/Setaraf
                                      Bintang 5
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Arjwan Al Difayah/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 10 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 10 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                     className="feature-item"
                                     data-bs-toggle="tooltip"
                                     data-bs-placement="top"
                                     title="Free City Tour Dubai"
                                  >
                                    <i
                                        className="fas fa-city text-primary mb-2"
                                        style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Free City Tour Dubai
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>

                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#spbpackagedoubleDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="spbpackagedoubleDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket Double:
                                </h5>
                                <p>Detail Paket Double</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <button
                          className="btn btn-primary"
                          onClick={handleBack}
                          style={{ fontWeight: 'bold' }}
                        >
                          Kembali Pilih Bulan
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </>

          <>
            {/* Paket Umrah 6 Oktober 2025 */}
            {selectedMonth === 'Oktober' && selectedDate === 6 && (
              <div className="row g-4 justify-content-center">
                {!showOabDetail && !showOamDetail ? (
                  <>
                    {/* Paket Umrah Akbar Berkah*/}
                    <div
                      className="col-lg-6 col-md-6 col-sm-12 wow fadeInUp"
                      data-wow-delay="0.1s"
                    >
                      <div className="package-item h-100 d-flex flex-column">
                        <div className="overflow-hidden">
                          <img
                            className="img-fluid w-100"
                            src="./assets/img/umroh/UMROH AKBAR BERKAH 06 OKTOBER 2025.jpg"
                            alt="Paket Umrah Akbar Berkah 6 Oktober"
                          />
                        </div>
                        <div className="d-flex border-bottom">
                          <small className="flex-fill text-center border-end py-2">
                            <i className="fa fa-calendar-alt text-primary me-2" />
                            10 Hari
                          </small>
                        </div>
                        <div className="text-center p-4 flex-grow-1 d-flex flex-column justify-content-between">
                          <div>
                            <span className="badge bg-primary mb-2">
                              Umrah Akbar Berkah
                            </span>
                            <h3 className="mb-0" style={{ color: 'black' }}>
                              Dimulai dari Rp. 29.5 Juta
                            </h3>
                            <p>
                              <i class="fa fa-building m-2"></i> Makkah: Maysan
                              Al Maqam/ Setaraf Bintang 3
                            </p>
                            <p>
                              <i class="fa fa-building m-2"></i> Madinah: Arjwan
                              Al Difayah/ Setaraf Bintang 3
                            </p>
                            <button
                              onClick={toggleContacts}
                              style={{
                                fontSize: '14px',
                                padding: '8px 16px',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease',
                              }}
                              className="contact-button"
                            >
                              <i
                                className="fas fa-phone-alt"
                                style={{ marginRight: '8px' }}
                              ></i>
                              Punya Pertanyaan ?
                            </button>

                            {showContacts && (
                              <div
                                style={{
                                  textAlign: 'center',
                                  fontSize: '18px',
                                  marginTop: '10px',
                                }}
                              >
                                <p>
                                  Rafi:{' '}
                                  <a
                                    href="https://wa.me/082136361688"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                                <p>
                                  Nanang:{' '}
                                  <a
                                    href="https://wa.me/081288596966"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                                <p>
                                  Call Center:{' '}
                                  <a
                                    href="https://wa.me/08118810491"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                              </div>
                            )}
                          </div>
                          <a
                            href="#"
                            className="btn btn-outline-primary mt-3"
                            onClick={handleOabClick}
                          >
                            Lihat Detail Paket
                          </a>
                        </div>
                      </div>
                    </div>

                    {/* Paket Umrah Akbar Mumtaaz*/}
                    <div
                      className="col-lg-6 col-md-6 col-sm-12 wow fadeInUp"
                      data-wow-delay="0.3s"
                    >
                      <div className="package-item h-100 d-flex flex-column">
                        <div className="overflow-hidden">
                          <img
                            className="img-fluid w-100"
                            src="./assets/img/umroh/UMROH AKBAR MUMTAAZ 06 OKTOBER 2025.jpg"
                            alt="Paket Umrah Mumtaaz"
                          />
                        </div>
                        <div className="d-flex border-bottom">
                          <small className="flex-fill text-center border-end py-2">
                            <i className="fa fa-calendar-alt text-primary me-2" />
                            10 Hari
                          </small>
                        </div>
                        <div className="text-center p-4 flex-grow-1 d-flex flex-column justify-content-between">
                          <div>
                            <span className="badge bg-primary mb-2">
                              Umrah Mumtaaz
                            </span>
                            <h3 className="mb-0" style={{ color: 'black' }}>
                              Dimulai dari Rp. 36 Juta
                            </h3>
                            <p>
                              <i class="fa fa-building m-2"></i>Makkah: Dorrar
                              Al Eiman / Setaraf Bintang 5
                            </p>
                            <p>
                              <i class="fa fa-building m-2"></i>Madinah: Arjwan
                              Al Difayah/ Setaraf Bintang 3
                            </p>
                            <button
                              onClick={toggleContacts}
                              style={{
                                fontSize: '14px',
                                padding: '8px 16px',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease',
                              }}
                              className="contact-button"
                            >
                              <i
                                className="fas fa-phone-alt"
                                style={{ marginRight: '8px' }}
                              ></i>
                              Punya Pertanyaan ?
                            </button>

                            {showContacts && (
                              <div
                                style={{
                                  textAlign: 'center',
                                  fontSize: '18px',
                                  marginTop: '10px',
                                }}
                              >
                                <p>
                                  Rafi:{' '}
                                  <a
                                    href="https://wa.me/082136361688"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                                <p>
                                  Nanang:{' '}
                                  <a
                                    href="https://wa.me/081288596966"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                                <p>
                                  Call Center:{' '}
                                  <a
                                    href="https://wa.me/08118810491"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    WhatsApp
                                  </a>
                                </p>
                              </div>
                            )}
                          </div>
                          <a
                            href="#"
                            className="btn btn-outline-primary mt-3"
                            onClick={handleOamClick}
                          >
                            Lihat Detail Paket
                          </a>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    {showOabDetail && (
                      // Paket Umrah Berkah 15 September
                      <div className="col-12 text-center">
                        <div className="h-100">
                          <img
                            className="img-fluid w-50 mb-4"
                            src="./assets/img/umroh/UMROH AKBAR BERKAH 06 OKTOBER 2025.jpg"
                            alt="Detail Umroh Akbar Berkah"
                          />
                          <h3 style={{ color: 'black' }}>
                            Detail Umroh Akbar Berkah
                          </h3>
                          <p class="stabilo1 sub-text">
                            Wujudkan Perjalanan Ibadah Impian Anda dengan Umroh
                            Akbar Berkah! ✨
                          </p>
                          <p class="stabilo2 sub-text">
                            Umroh Akbar Berkah menawarkan perjalanan spiritual
                            dengan layanan premium, menjadikan ibadah Anda lebih
                            bermakna. Segera daftarkan diri Anda, tempat
                            terbatas!"
                          </p>
                          <div className="row g-4 justify-content-center">
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              {/* Paket Quad */}
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Umrah Berkah Plus Thaif"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Quad
                                    <br />
                                    <span style={{ color: '#cfa936' }}>
                                      (29.5 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={toggleOrderOabQuad6OktoberForm}
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderOabQuad6OktoberForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={handleSubmitOrderOabQuad6Oktober}
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Saudia Airlines</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Maysan Al Maqam/Setaraf
                                          Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Maysan Al Maqam/Setaraf
                                          Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Arjwan Al Difayah/ Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Arjwan Al Difayah/
                                          Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 10 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 10 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#oabpackagequadDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="oabpackagequadDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket :
                                    </h5>
                                    <p>Penjelasan detail paket quad</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Paket Triple */}
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Umroh Berkah Spesial Muharam"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Triple <br />
                                    <span style={{ color: '#cfa936' }}>
                                      (32 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={toggleOrderOabTriple6OktoberForm}
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderOabTriple6OktoberForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderOabTriple6Oktober
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Saudia Airlines</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Maysan Al Maqam/Setaraf
                                          Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Maysan Al Maqam/Setaraf
                                          Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Arjwan Al Difayah/ Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Arjwan Al Difayah/
                                          Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 10 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 10 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#oabpackagetripleDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="oabpackagetripleDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket :
                                    </h5>
                                    <p>Penjelasan detail paket</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Paket Double */}
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Double"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Double <br />
                                    <span className="text-gold exclusive">
                                      (33 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={toggleOrderOabDouble6OktoberForm}
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderOabDouble6OktoberForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderOabDouble6Oktober
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Saudia Airlines</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Maysan Al Maqam/Setaraf
                                          Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Maysan Al Maqam/Setaraf
                                          Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Arjwan Al Difayah/ Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Arjwan Al Difayah/
                                          Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 10 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 10 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#oabpackagedoubleDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="oabpackagedoubleDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket Double:
                                    </h5>
                                    <p>Detail Paket Double</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <button
                              className="btn btn-primary"
                              onClick={handleBack}
                              style={{ fontWeight: 'bold' }}
                            >
                              Kembali Pilih Bulan
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    {showOamDetail && (
                      // Paket Umrah Akbar Mumtaaz
                      <div className="col-12 text-center">
                        <div className="h-100">
                          <img
                            className="img-fluid w-50 mb-4"
                            src="./assets/img/umroh/UMROH AKBAR MUMTAAZ 06 OKTOBER 2025.jpg"
                            alt="Detail Umrah Mumtaaz"
                          />
                          <h3 style={{ color: 'black' }}>
                            Detail Paket Umrah Akbar Mumtaaz
                          </h3>
                          <p class="stabilo1 sub-text">
                            Paket Umrah Akbar Mumtaaz: Ibadah Penuh Keberkahan
                            dengan Kenyamanan Maksimal! 🌟
                          </p>
                          <p class="stabilo2 sub-text">
                            Nikmati perjalanan ibadah yang lebih istimewa dengan
                            Paket Umrah Akbar Mumtaaz. Fasilitas terbaik dan
                            pelayanan luar biasa akan membuat perjalanan Anda
                            lebih bermakna. Segera daftar, tempat terbatas!"
                          </p>
                          <div className="row g-4 justify-content-center">
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              {/* Paket Quad */}
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Umroh Mumtaaz Spesial Muharram"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Quad
                                    <br />
                                    <span style={{ color: '#cfa936' }}>
                                      (36 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={toggleOrderOamQuad6OktoberForm}
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderOamQuad6OktoberForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={handleSubmitOrderOamQuad6Oktober}
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Saudia Airlines</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Dorrar Al Eiman/Setaraf Bintang 5"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Dorrar Al Eiman/Setaraf
                                          Bintang 5
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Arjwan Al Difayah/ Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Arjwan Al Difayah/
                                          Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah selama 10 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 10 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#oampackagequadDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="oampackagequadDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket :
                                    </h5>
                                    <p>Penjelasan detail paket quad</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Paket Triple */}
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Umroh Triple"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Triple <br />
                                    <span style={{ color: '#cfa936' }}>
                                      (38.5 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={toggleOrderOamTriple6OktoberForm}
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderOamTriple6OktoberForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderOamTriple6Oktober
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Saudia Airlines</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Dorrar Al Eiman/Setaraf Bintang 5"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Dorrar Al Eiman/Setaraf
                                          Bintang 5
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Arjwan Al Difayah/ Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Arjwan Al Difayah/
                                          Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 10 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 10 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#oampackagetripleDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="oampackagetripleDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket :
                                    </h5>
                                    <p>Penjelasan detail paket</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Paket Double */}
                            <div
                              className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                              data-wow-delay="0.1s"
                            >
                              <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                                <div className="pricing-header text-center mb-4 position-relative">
                                  <img
                                    src="assets/img/banner/artboard-1.jpg"
                                    alt="Paket Double"
                                    className="w-100 rounded-3 img-fluid"
                                  />
                                  <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                    Paket Double <br />
                                    <span className="text-gold exclusive">
                                      (39.5 Juta)
                                    </span>
                                  </h3>
                                </div>

                                <a
                                  href="#"
                                  className="btn btn-outline-primary mt-3 mb-2"
                                  onClick={toggleOrderOamDouble6OktoberForm}
                                >
                                  Klik untuk Pemesanan
                                </a>
                                {showOrderOamDouble6OktoberForm && (
                                  <div
                                    style={{ marginTop: '20px' }}
                                    id="paket-umrah-order"
                                  >
                                    <input
                                      type="text"
                                      placeholder="Nama Lengkap"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      style={{ padding: '10px', width: '100%' }}
                                    />
                                    <input
                                      type="text"
                                      placeholder="Nomor Telepon"
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="date"
                                      placeholder="Tanggal Lahir"
                                      value={dob}
                                      onChange={(e) => setDob(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <select
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    >
                                      <option value="">
                                        Pilih Jenis Kelamin
                                      </option>
                                      <option value="Laki-laki">
                                        Laki-laki
                                      </option>
                                      <option value="Perempuan">
                                        Perempuan
                                      </option>
                                    </select>
                                    <textarea
                                      placeholder="Alamat Lengkap"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        width: '100%',
                                        marginTop: '10px',
                                      }}
                                    />
                                    <div>
                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        KTP :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="ktp"
                                          onChange={() => setKtp('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="ktp"
                                          onChange={() => setKtp('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Kartu Keluarga :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="kk"
                                          onChange={() => setKk('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="kk"
                                          onChange={() => setKk('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Pas Foto :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="photo"
                                          onChange={() => setPhoto('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="photo"
                                          onChange={() => setPhoto('tidak ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>

                                      <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        Paspor :
                                        <input
                                          type="radio"
                                          value="ada"
                                          name="passport"
                                          onChange={() => setPassport('ada')}
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Ada
                                        <input
                                          type="radio"
                                          value="tidak ada"
                                          name="passport"
                                          onChange={() =>
                                            setPassport('tidak ada')
                                          }
                                          style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                          }}
                                        />
                                        Tidak Ada
                                      </label>
                                    </div>

                                    <button
                                      onClick={
                                        handleSubmitOrderOamDouble6Oktober
                                      }
                                      className="btn btn-primary mt-3"
                                      style={{ width: '100%' }}
                                    >
                                      Kirim Order ke WhatsApp
                                    </button>
                                  </div>
                                )}

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-outline-primary-konversi w-100"
                                    style={{ pointerEvents: 'none' }}
                                  >
                                    Harga Include
                                  </button>
                                </div>
                                <div className="pricing-features mb-4">
                                  <div className="row">
                                    {/* Menampilkan fitur dalam dua kolom */}
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Visa Umrah"
                                      >
                                        <i
                                          className="fa fa-address-book text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Visa Umrah</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tiket Pesawat"
                                      >
                                        <i
                                          className="fa fa-plane text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Tiket Pesawat Saudia Airlines</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Makkah Dorrar Al Eiman/Setaraf
                                          Bintang 5"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Makkah Dorrar Al Eiman/Setaraf
                                          Bintang 5
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Hotel Madinah Arjwan Al Difayah/ Setaraf Bintang 3"
                                      >
                                        <i
                                          className="fa fa-building text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Hotel Madinah Arjwan Al Difayah/
                                          Setaraf Bintang 3
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Program Umrah Selama 10 Hari"
                                      >
                                        <i
                                          className="fa fa-calendar text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Program 10 Hari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                      >
                                        <i
                                          className="fa fa-tshirt text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Perlengkapan & Manasik Senilai 1,5
                                          Juta
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Asuransi Perjalanan"
                                      >
                                        <i
                                          className="fa fa-user-shield text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Asuransi Perjalanan</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Ziarah & City Tour"
                                      >
                                        <i
                                          className="fa fa-street-view text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Ziarah dan City Tour</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Bagasi 23 kg/pax"
                                      >
                                        <i
                                          className="fa fa-suitcase-rolling text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bagasi 23 kg/pax</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Tour Leader dan Muthawif yang berkompeten"
                                      >
                                        <i
                                          className="fa fa-users text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>
                                          Tour Leader dan Muthawif yang
                                          Berkompeten
                                        </p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-snowflake text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Lounge</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-bus text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Bus AC</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fas fa-drumstick-bite text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Makan 3x Sehari</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-cookie text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Welcome Food</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Air Zam-Zam 5 liter"
                                      >
                                        <i
                                          className="fa fa-tint text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Air Zam-Zam 5 liter</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-camera text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Free Dokumentasi</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-tools text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Handling</p>
                                      </div>
                                      <div
                                        className="feature-item"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Akses ke lounge eksklusif di lokasi tertentu"
                                      >
                                        <i
                                          className="fa fa-check-circle text-primary mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Full Service</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-center">
                                    <button className="btn btn-outline-primary-exclude w-100 my-4">
                                      Harga Exclude
                                    </button>
                                  </div>

                                  {/* Exlude */}
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Pembuatan Paspor"
                                      >
                                        <i
                                          className="fa fa-address-book mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Pembuatan Paspor</p>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="feature-item-exclude"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Vaksin Meningitis"
                                      >
                                        <i
                                          className="fa fa-syringe mb-2"
                                          style={{ fontSize: '2rem' }}
                                        ></i>
                                        <p>Vaksin Meningitis</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-center mt-auto">
                                  <button
                                    className="btn btn-primary w-100 mt-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#oampackagedoubleDetails"
                                  >
                                    Deskripsi Paket
                                  </button>
                                </div>

                                <div
                                  id="oampackagedoubleDetails"
                                  className="collapse"
                                >
                                  <div className="mt-3 p-3 bg-light rounded">
                                    <h5
                                      className="font-weight-bold"
                                      style={{ color: 'goldenrod' }}
                                    >
                                      Detail Paket Double:
                                    </h5>
                                    <p>Detail Paket Double</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <button
                              className="btn btn-primary"
                              onClick={handleBack}
                              style={{ fontWeight: 'bold' }}
                            >
                              Kembali Pilih Bulan
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            )}

            {/* Paket Umrah 20 Oktober 2025 */}
            {selectedMonth === 'Oktober' && selectedDate === 20 && (
              <div className="row g-4 justify-content-center">
                {showObThaifDetail && (
                  <div className="col-12 text-center">
                    <div className="h-100">
                      <img
                        className="img-fluid w-50 mb-4"
                        src="./assets/img/umroh/UMROH BERKAH PLUS THAIF 20 OKTOBER 2025.jpg"
                        alt="Detail Umroh Plus Dubai"
                      />
                      <h3 style={{ color: 'black' }}>
                        Detail Paket Umrah Berkah Plus Thaif
                      </h3>
                      <p class="stabilo1 sub-text">
                        Paket Umrah Berkah Plus Thaif: Perjalanan Ibadah dengan
                        Keberkahan dan Keindahan Thaif! 🌙
                      </p>
                      <p class="stabilo2 sub-text">
                        Gabungkan perjalanan ibadah yang penuh berkah dengan
                        kunjungan ke Thaif yang menakjubkan. Nikmati fasilitas
                        terbaik dan pengalaman spiritual yang luar biasa. Daftar
                        sekarang, tempat terbatas!"
                      </p>
                      <div className="row g-4 justify-content-center">
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          {/* Paket Quad Room */}
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Umrah Berkah Plus Thaif"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Quad
                                <br />
                                <span style={{ color: '#cfa936' }}>
                                  (28.5 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderObThaifQuad20OktoberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderObThaifQuad20OktoberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={
                                    handleSubmitOrderObThaifQuad20Oktober
                                  }
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                     className="feature-item"
                                     data-bs-toggle="tooltip"
                                     data-bs-placement="top"
                                     title="Free Kereta Gantung"
                                    >
                                      <i
                                      className="fas fa-tram  text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                      ></i>
                                        <p>Free Kereta Gantung</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Etihad</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Zuwar Al Bayt/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Zuwar Al Bayt/Setaraf Bintang
                                      3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Jawharat Al Rasheed/ Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Jawharat Al Rasheed/ Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 9 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 9 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Free City Tour Thaif"
                                  >
                                    <i
                                      className="fas fa-city text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Free City Tour Thaif
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>

                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#obthaifpackagequadDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="obthaifpackagequadDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket :
                                </h5>
                                <p>Penjelasan detail paket quad</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Paket Triple */}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Umroh Plus Dubai"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Triple <br />
                                <span style={{ color: '#cfa936' }}>
                                  (31 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderObThaifTriple20OktoberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderObThaifTriple20OktoberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={
                                    handleSubmitOrderObThaifTriple20Oktober
                                  }
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                   <div
                                     className="feature-item"
                                     data-bs-toggle="tooltip"
                                     data-bs-placement="top"
                                     title="Free Kereta Gantung"
                                    >
                                      <i
                                      className="fas fa-tram  text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                      ></i>
                                        <p>Free Kereta Gantung</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Etihad</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Zuwar Al Bayt/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Zuwar Al Bayt/Setaraf Bintang
                                      3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Jawharat Al Rasheed/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Jawharat Al Rasheed/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 9 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 9 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Free City Tour Thaif"
                                  >
                                    <i
                                      className="fas fa-city text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Free City Tour Thaif
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>
                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#obthaifpackagetripleDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="obthaifpackagetripleDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket :
                                </h5>
                                <p>Penjelasan detail paket</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Paket Double */}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Double"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Double <br />
                                <span className="text-gold exclusive">
                                  (32 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderObThaifDouble20OktoberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderObThaifDouble20OktoberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={
                                    handleSubmitOrderObThaifDouble20Oktober
                                  }
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                   <div
                                     className="feature-item"
                                     data-bs-toggle="tooltip"
                                     data-bs-placement="top"
                                     title="Free Kereta Gantung"
                                    >
                                      <i
                                      className="fas fa-tram  text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                      ></i>
                                        <p>Free Kereta Gantung</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Etihad</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Zuwar Al Bayt/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Zuwar Al Bayt/Setaraf Bintang
                                      3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Jawharat Al Rasheed/Setaraf
                                      Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Jawharat Al Rasheed/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 9 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 9 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Free City Tour Thaif"
                                  >
                                    <i
                                      className="fas fa-city text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Free City Tour Thaif
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>

                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#obthaifpackagedoubleDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="obthaifpackagedoubleDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket Double:
                                </h5>
                                <p>Detail Paket Double</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <button
                          className="btn btn-primary"
                          onClick={handleBack}
                          style={{ fontWeight: 'bold' }}
                        >
                          Kembali Pilih Bulan
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </>

          <>
            {/* Paket Umrah 03 November 2025 */}
            {selectedMonth === 'November' && selectedDate === 3 && (
              <div className="row g-4 justify-content-center">
                {showNmfsDetail && (
                  <div className="col-12 text-center">
                    <div className="h-100">
                      <img
                        className="img-fluid w-50 mb-4"
                        src="./assets/img/umroh/UMROH MUNAJAT FAMILY SERIES 03 NOVEMBER 2025.jpg"
                        alt="Detail Umrah Munajat Family Series"
                      />
                      <h3 style={{ color: 'black' }}>
                        Detail Paket Umrah Munajat Family Series
                      </h3>
                      <p class="stabilo1 sub-text">
                        Paket Umrah Munajat Family Series: Perjalanan Ibadah
                        Keluarga dengan Doa dan Keberkahan! 🌙
                      </p>
                      <p class="stabilo2 sub-text">
                        Ajak keluarga tercinta untuk merasakan perjalanan ibadah
                        yang penuh berkah dengan Paket Umrah Munajat Family
                        Series. Nikmati pengalaman spiritual bersama dalam
                        suasana penuh doa dan kedamaian. Daftar sekarang, tempat
                        terbatas!"
                      </p>
                      <div className="row g-4 justify-content-center">
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          {/* Paket Quad Room */}
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Umrah Munajat Family Series"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Quad
                                <br />
                                <span style={{ color: '#cfa936' }}>
                                  (35.5 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderNmfsQuad3NovemberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderNmfsQuad3NovemberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={handleSubmitOrderNmfsQuad3November}
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Saudia Airlines</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Rayyana/Setaraf Bintang 4"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Rayyana/Setaraf Bintang 4
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Grand Plaza/ Setaraf Bintang 4"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Grand Plaza/ Setaraf Bintang
                                      4
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 9 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 9 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>

                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#nmfspackagequadDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="nmfspackagequadDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket :
                                </h5>
                                <p>Penjelasan detail paket quad</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Paket Triple */}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Umroh Plus Dubai"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Triple <br />
                                <span style={{ color: '#cfa936' }}>
                                  (38 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderNmfsTriple3NovemberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderNmfsTriple3NovemberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={handleSubmitOrderNmfsTriple3November}
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Saudia Airlines</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Rayyana/Setaraf Bintang 4"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Rayyana/Setaraf Bintang 4
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Grand Plaza/Setaraf Bintang 4"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Grand Plaza/Setaraf Bintang
                                      4
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 9 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 9 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>
                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#nmfspackagetripleDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="nmfspackagetripleDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket :
                                </h5>
                                <p>Penjelasan detail paket</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Paket Double */}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Double"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Double <br />
                                <span className="text-gold exclusive">
                                  (39 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderNmfsDouble3NovemberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderNmfsDouble3NovemberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={handleSubmitOrderNmfsDouble3November}
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Saudia Airlines</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Rayyana/Setaraf Bintang 4"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Rayyana/Setaraf Bintang 4
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Grand Plaza /Setara Bintang 4"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Grand Plaza /Setara Bintang
                                      4
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 9 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 9 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>

                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#nmfspackagedoubleDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="nmfspackagedoubleDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket Double:
                                </h5>
                                <p>Detail Paket Double</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <button
                          className="btn btn-primary"
                          onClick={handleBack}
                          style={{ fontWeight: 'bold' }}
                        >
                          Kembali Pilih Bulan
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Paket Umrah 05 November 2025 */}
            {selectedMonth === 'November' && selectedDate === 5 && (
              <div className="row g-4 justify-content-center">
                {showNbDetail && (
                  <div className="col-12 text-center">
                    <div className="h-100">
                      <img
                        className="img-fluid w-50 mb-4"
                        src="./assets/img/umroh/UMROH BERKAH 2X JUM'AT 05 NOVEMBER 2025.jpg"
                        alt="Detail Umrah Berkah 5 November"
                      />
                      <h3 style={{ color: 'black' }}>
                        Detail Paket Umrah Berkah
                      </h3>
                      <p class="stabilo1 sub-text">
                        Raih Keberkahan di Tanah Suci dengan Paket Umrah Berkah!
                        🕋
                      </p>
                      <p class="stabilo2 sub-text">
                        Paket Umrah Berkah menawarkan perjalanan ibadah yang
                        penuh makna dan kenyamanan. Dapatkan pengalaman
                        spiritual yang tidak terlupakan. Daftar sekarang, tempat
                        terbatas!"
                      </p>
                      <div className="row g-4 justify-content-center">
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          {/* Paket Quad Room */}
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Umrah Berkah"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Quad
                                <br />
                                <span style={{ color: '#cfa936' }}>
                                  (27.9 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderNbQuad5NovemberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderNbQuad5NovemberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={handleSubmitOrderNbQuad5November}
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Oman Air</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Dyar Al Bayt/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Dyar Al Bayt/Setaraf Bintang
                                      3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Jawharat Ar Rasheed/ Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Jawharat Ar Rasheed/ Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 12 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 12 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>

                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#nbpackagequadDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div id="nbpackagequadDetails" className="collapse">
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket :
                                </h5>
                                <p>Penjelasan detail paket quad</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Paket Triple */}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Triple"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Triple <br />
                                <span style={{ color: '#cfa936' }}>
                                  (30.4 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderNbTriple5NovemberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderNbTriple5NovemberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={handleSubmitOrderNbTriple5November}
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Oman Air</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Dyar Al Bayt/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Dyar Al Bayt/Setaraf Bintang
                                      3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Jawharat Ar Rasheed/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Jawharat Ar Rasheed/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 12 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 12 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>
                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#nbpackagetripleDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="nbpackagetripleDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket :
                                </h5>
                                <p>Penjelasan detail paket</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Paket Double */}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Double"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Double <br />
                                <span className="text-gold exclusive">
                                  (31.4 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderNbDouble5NovemberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderNbDouble5NovemberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={handleSubmitOrderNbDouble5November}
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Oman Air</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Dyar Al Bayt/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Dyar Al Bayt/Setaraf Bintang
                                      3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Jawharat Ar Rasheed /Setara Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Jawharat Ar Rasheed /Setara
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 12 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 12 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>

                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#nbpackagedoubleDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="nbpackagedoubleDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket Double:
                                </h5>
                                <p>Detail Paket Double</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <button
                          className="btn btn-primary"
                          onClick={handleBack}
                          style={{ fontWeight: 'bold' }}
                        >
                          Kembali Pilih Bulan
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Paket Umrah 19 November 2025 */}
            {selectedMonth === 'November' && selectedDate === 19 && (
              <div className="row g-4 justify-content-center">
                {showNpdsddDetail && (
                  <div className="col-12 text-center">
                    <div className="h-100">
                      <img
                        className="img-fluid w-50 mb-4"
                        src="./assets/img/umroh/UMROH PLUS DUBAI SAFARI DESSERT 19 NOVEMBER 2025.jpg"
                        alt="Detail Umrah Plus Dubai Safari Dessert Dubai"
                      />
                      <h3 style={{ color: 'black' }}>
                        Detail Paket Umrah Plus Dubai Safari Dessert Dubai
                      </h3>
                      <p class="stabilo1 sub-text">
                        Paket Umrah Plus Dubai Safari Desert: Ibadah dan
                        Petualangan Seru di Dubai! ✨
                      </p>
                      <p class="stabilo2 sub-text">
                        Gabungkan perjalanan ibadah yang penuh berkah dengan
                        liburan seru di Dubai. Paket Umrah Plus Dubai menawarkan
                        pengalaman spiritual dan wisata kelas dunia. Daftar
                        sekarang, tempat terbatas!"
                      </p>
                      <div className="row g-4 justify-content-center">
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          {/* Paket Quad Room */}
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Umrah Berkah"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Quad
                                <br />
                                <span style={{ color: '#cfa936' }}>
                                  (36.9 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderNpdsdQuad19NovemberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderNpdsdQuad19NovemberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={handleSubmitOrderNpdsdQuad19November}
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                   <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Free Safari Dessert"
                                  >
                                    <i
                                      className="fas fa-truck-monster text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Safari Dessert</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Emirates</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Dorrar Al Eiman/Setaraf Bintang 5"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Dorrar Al Eiman/Setaraf
                                      Bintang 5
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Arjwan Al Difayah/ Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Arjwan Al Difayah/ Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 12 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 12 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>

                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#npdsddpackagequadDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="npdsddpackagequadDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket :
                                </h5>
                                <p>Penjelasan detail paket quad</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Paket Triple */}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Triple"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Triple <br />
                                <span style={{ color: '#cfa936' }}>
                                  (40.4 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderNpdsdTriple19NovemberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderNpdsdTriple19NovemberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={
                                    handleSubmitOrderNpdsdTriple19November
                                  }
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                   <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Free Safari Dessert"
                                  >
                                    <i
                                      className="fas fa-truck-monster text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Safari Dessert</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Emirates</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Dorrar Al Eiman/Setaraf Bintang 5"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Dorrar Al Eiman/Setaraf
                                      Bintang 5
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Arjwan Al Difayah/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Arjwan Al Difayah/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 12 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 12 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>
                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#npdsddpackagetripleDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="npdsddpackagetripleDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket :
                                </h5>
                                <p>Penjelasan detail paket</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Paket Double */}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Double"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Double <br />
                                <span className="text-gold exclusive">
                                  (41.4 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderNpdsdDouble19NovemberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderNpdsdDouble19NovemberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={
                                    handleSubmitOrderNpdsdDouble19November
                                  }
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Free Safari Dessert"
                                  >
                                    <i
                                      className="fas fa-truck-monster text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Safari Dessert</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Emirates</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Dyar Al Bayt/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Dorrar Al Eiman/Setaraf
                                      Bintang 5
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Arjwan Al Difayah/Setara Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Arjwan Al Difayah/Setara
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 12 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 12 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>

                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#npdsddpackagedoubleDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="npdsddpackagedoubleDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket Double:
                                </h5>
                                <p>Detail Paket Double</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <button
                          className="btn btn-primary"
                          onClick={handleBack}
                          style={{ fontWeight: 'bold' }}
                        >
                          Kembali Pilih Bulan
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Paket Umrah 26 November 2025 */}
            {selectedMonth === 'November' && selectedDate === 26 && (
              <div className="row g-4 justify-content-center">
                {showNlbDetail && (
                  <div className="col-12 text-center">
                    <div className="h-100">
                      <img
                        className="img-fluid w-50 mb-4"
                        src="./assets/img/umroh/UMROH BERKAH BY LION 26 NOVEMBER 2025 REVISI.jpg"
                        alt="Detail Umrah Berkah By Lion"
                      />
                      <h3 style={{ color: 'black' }}>
                        Detail Paket Umrah Berkah
                      </h3>
                      <p class="stabilo1 sub-text">
                        Raih Keberkahan di Tanah Suci dengan Paket Umrah Berkah!
                        🕋
                      </p>
                      <p class="stabilo2 sub-text">
                        Paket Umrah Berkah menawarkan perjalanan ibadah yang
                        penuh makna dan kenyamanan. Dapatkan pengalaman
                        spiritual yang tidak terlupakan. Daftar sekarang, tempat
                        terbatas!"
                      </p>
                      <div className="row g-4 justify-content-center">
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          {/* Paket Quad Room */}
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Umrah Berkah"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Quad
                                <br />
                                <span style={{ color: '#cfa936' }}>
                                  (27.9 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderNlbQuad26NovemberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderNlbQuad26NovemberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={handleSubmitOrderNlbQuad26November}
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Lion Air</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Maysan Al Maqam/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Maysan Al Maqam/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Arjwan Al Difayah/ Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Arjwan Al Difayah/ Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 9 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 9 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>

                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#nlbpackagequadDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="nlbpackagequadDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket :
                                </h5>
                                <p>Penjelasan detail paket quad</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Paket Triple */}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Triple"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Triple <br />
                                <span style={{ color: '#cfa936' }}>
                                  (30.4 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderNlbTriple26NovemberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderNlbTriple26NovemberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={handleSubmitOrderNlbTriple26November}
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Lion Air</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Maysan Al Maqam/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Maysan Al Maqam/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Arjwan Al Difayah/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Arjwan Al Difayah/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 9 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 9 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>
                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#nlbpackagetripleDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="nlbpackagetripleDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket :
                                </h5>
                                <p>Penjelasan detail paket</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Paket Double */}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Double"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Double <br />
                                <span className="text-gold exclusive">
                                  (31.4 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderNlbDouble26NovemberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderNlbDouble26NovemberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={handleSubmitOrderNlbDouble26November}
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Lion Air</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Maysan Al Maqan/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Maysan Al Maqan/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Arjwan Al Difayah/Setara Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Arjwan Al Difayah/Setara
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 9 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 9 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>

                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#nlbpackagedoubleDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="nlbpackagedoubleDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket Double:
                                </h5>
                                <p>Detail Paket Double</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <button
                          className="btn btn-primary"
                          onClick={handleBack}
                          style={{ fontWeight: 'bold' }}
                        >
                          Kembali Pilih Bulan
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </>

          <>
            {/* Paket Umrah 03 Desember 2025 */}
            {selectedMonth === 'Desember' && selectedDate === 3 && (
              <div className="row g-4 justify-content-center">
                {showDbsatDetail && (
                  <div className="col-12 text-center">
                    <div className="h-100">
                      <img
                        className="img-fluid w-50 mb-4"
                        src="./assets/img/umroh/UMROH BERKAH SPESIAL AKHIR TAHUN 03 DESEMBER 2025.jpg"
                        alt="Detail Umrah Berkah Spesial Akhir Tahun"
                      />
                      <h3 style={{ color: 'black' }}>
                        Detail Paket Umrah Berkah Spesial Akhir Tahun
                      </h3>
                      <p class="stabilo1 sub-text">
                        Paket Umrah Berkah Spesial Akhir Tahun: Perjalanan
                        Ibadah Penuh Keberkahan Menyambut Tahun Baru! 🌙
                      </p>
                      <p class="stabilo2 sub-text">
                        Nikmati keberkahan ibadah umrah di akhir tahun dengan
                        Paket Umrah Berkah Spesial Akhir Tahun. Wujudkan
                        perjalanan spiritual yang tak terlupakan, penuh makna,
                        dan keberkahan. Daftar sekarang, tempat terbatas!"
                      </p>
                      <div className="row g-4 justify-content-center">
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          {/* Paket Quad Room */}
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Umrah Berkah"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Quad
                                <br />
                                <span style={{ color: '#cfa936' }}>
                                  (29.5 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderDbsatQuad3DesemberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderDbsatQuad3DesemberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={handleSubmitOrderDbsatQuad3Desember}
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Saudia Airlines</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Maysan Al Maqam/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Maysan Al Maqam/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Arjwan Al Difayah/ Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Arjwan Al Difayah/ Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 9 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 9 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>

                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#dbsatpackagequadDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="dbsatpackagequadDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket :
                                </h5>
                                <p>Penjelasan detail paket quad</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Paket Triple */}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Triple"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Triple <br />
                                <span style={{ color: '#cfa936' }}>
                                  (33 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderDbsatTriple3DesemberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderDbsatTriple3DesemberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={
                                    handleSubmitOrderDbsatTriple3Desember
                                  }
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Saudia Airlines</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Maysan Al Maqam/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Maysan Al Maqam/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Arjwan Al Difayah/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Arjwan Al Difayah/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 9 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 9 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>
                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#dbsatpackagetripleDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="dbsatpackagetripleDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket :
                                </h5>
                                <p>Penjelasan detail paket</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Paket Double */}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Double"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Double <br />
                                <span className="text-gold exclusive">
                                  (34 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderDbsatDouble3DesemberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderDbsatDouble3DesemberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={
                                    handleSubmitOrderDbsatDouble3Desember
                                  }
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Saudia Airlines</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Maysan Al Maqan/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Maysan Al Maqan/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Arjwan Al Difayah/Setara Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Arjwan Al Difayah/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 9 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 9 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>

                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#dbsatpackagedoubleDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="dbsatpackagedoubleDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket Double:
                                </h5>
                                <p>Detail Paket Double</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <button
                          className="btn btn-primary"
                          onClick={handleBack}
                          style={{ fontWeight: 'bold' }}
                        >
                          Kembali Pilih Bulan
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Paket Umrah 24 Desember 2025 */}
            {selectedMonth === 'Desember' && selectedDate === 24 && (
              <div className="row g-4 justify-content-center">
                {showDbfsDetail && (
                  <div className="col-12 text-center">
                    <div className="h-100">
                      <img
                        className="img-fluid w-50 mb-4"
                        src="./assets/img/umroh/UMROH BERKAH FAMILY SERIES 24 DESEMBER 2025.jpg"
                        alt="Detail Umrah Berkah Spesial Akhir Tahun"
                      />
                      <h3 style={{ color: 'black' }}>
                        Detail Paket Umrah Berkah Family Series
                      </h3>
                      <p class="stabilo1 sub-text">
                        Paket Umrah Berkah Family Series: Ibadah Keluarga dengan
                        Kenyamanan Maksimal! ✨
                      </p>
                      <p class="stabilo2 sub-text">
                        Nikmati kenyamanan terbaik dan fasilitas premium dalam
                        Paket Umrah Berkah Family Series. Perjalanan ibadah
                        bersama keluarga yang penuh makna dan keberkahan menanti
                        Anda. Daftar segera sebelum tempat penuh!"
                      </p>
                      <div className="row g-4 justify-content-center">
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          {/* Paket Quad Room */}
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Umrah Berkah Family Series"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Quad
                                <br />
                                <span style={{ color: '#cfa936' }}>
                                  (33.5 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderDbfsQuad24DesemberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderDbfsQuad24DesemberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={handleSubmitOrderDbfsQuad24Desember}
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Saudia Airlines</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Maysan Al Maqam/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Maysan Al Maqam/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Arjwan Al Difayah/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Arjwan Al Difayah/ Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 9 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 9 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>

                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#dbfspackagequadDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="dbfspackagequadDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket :
                                </h5>
                                <p>Penjelasan detail paket quad</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Paket Triple */}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Triple"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Triple <br />
                                <span style={{ color: '#cfa936' }}>
                                  (37 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderDbfsTriple24DesemberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderDbfsTriple24DesemberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={
                                    handleSubmitOrderDbfsTriple24Desember
                                  }
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Saudia Airlines</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Maysan Al Maqam/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Maysan Al Maqam/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Arjwan Al Difayah/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Arjwan Al Difayah/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 9 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 9 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>
                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#dbfspackagetripleDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="dbfspackagetripleDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket :
                                </h5>
                                <p>Penjelasan detail paket</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Paket Double */}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Double"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Double <br />
                                <span className="text-gold exclusive">
                                  (38 Juta)
                                </span>
                              </h3>
                            </div>

                            <a
                              href="#"
                              className="btn btn-outline-primary mt-3 mb-2"
                              onClick={toggleOrderDbfsDouble24DesemberForm}
                            >
                              Klik untuk Pemesanan
                            </a>
                            {showOrderDbfsDouble24DesemberForm && (
                              <div
                                style={{ marginTop: '20px' }}
                                id="paket-umrah-order"
                              >
                                <input
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  style={{ padding: '10px', width: '100%' }}
                                />
                                <input
                                  type="text"
                                  placeholder="Nomor Telepon"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="date"
                                  placeholder="Tanggal Lahir"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <select
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                >
                                  <option value="">Pilih Jenis Kelamin</option>
                                  <option value="Laki-laki">Laki-laki</option>
                                  <option value="Perempuan">Perempuan</option>
                                </select>
                                <textarea
                                  placeholder="Alamat Lengkap"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    padding: '10px',
                                    width: '100%',
                                    marginTop: '10px',
                                  }}
                                />
                                <div>
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    KTP :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="ktp"
                                      onChange={() => setKtp('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="ktp"
                                      onChange={() => setKtp('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Kartu Keluarga :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="kk"
                                      onChange={() => setKk('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="kk"
                                      onChange={() => setKk('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Pas Foto :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="photo"
                                      onChange={() => setPhoto('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="photo"
                                      onChange={() => setPhoto('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>

                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Paspor :
                                    <input
                                      type="radio"
                                      value="ada"
                                      name="passport"
                                      onChange={() => setPassport('ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Ada
                                    <input
                                      type="radio"
                                      value="tidak ada"
                                      name="passport"
                                      onChange={() => setPassport('tidak ada')}
                                      style={{
                                        marginTop: '10px',
                                        marginLeft: '10px',
                                      }}
                                    />
                                    Tidak Ada
                                  </label>
                                </div>

                                <button
                                  onClick={
                                    handleSubmitOrderDbfsDouble24Desember
                                  }
                                  className="btn btn-primary mt-3"
                                  style={{ width: '100%' }}
                                >
                                  Kirim Order ke WhatsApp
                                </button>
                              </div>
                            )}

                            <div className="text-center mt-3">
                              <button
                                className="btn btn-outline-primary-konversi w-100"
                                style={{ pointerEvents: 'none' }}
                              >
                                Harga Include
                              </button>
                            </div>
                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa Umrah"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa Umrah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tiket Pesawat"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tiket Pesawat Saudia Airlines</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Makkah Maysan Al Maqan/Setaraf Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Makkah Maysan Al Maqan/Setaraf
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah Arjwan Al Difayah/Setara Bintang 3"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Arjwan Al Difayah/Setara
                                      Bintang 3
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Umrah Selama 9 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 9 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan & Manasik Senilai 1,5 Juta"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Perlengkapan & Manasik Senilai 1,5 Juta
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Asuransi Perjalanan"
                                  >
                                    <i
                                      className="fa fa-user-shield text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Asuransi Perjalanan</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Ziarah & City Tour"
                                  >
                                    <i
                                      className="fa fa-street-view text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Ziarah dan City Tour</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Bagasi 23 kg/pax"
                                  >
                                    <i
                                      className="fa fa-suitcase-rolling text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bagasi 23 kg/pax</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Bus AC</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Air Zam-Zam 5 liter"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Air Zam-Zam 5 liter</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>

                              <div className="text-center">
                                <button className="btn btn-outline-primary-exclude w-100 my-4">
                                  Harga Exclude
                                </button>
                              </div>

                              {/* Exlude */}
                              <div className="row">
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Pembuatan Paspor"
                                  >
                                    <i
                                      className="fa fa-address-book mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Pembuatan Paspor</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item-exclude"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Vaksin Meningitis"
                                  >
                                    <i
                                      className="fa fa-syringe mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Vaksin Meningitis</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#dbfspackagedoubleDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="dbfspackagedoubleDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket Double:
                                </h5>
                                <p>Detail Paket Double</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <button
                          className="btn btn-primary"
                          onClick={handleBack}
                          style={{ fontWeight: 'bold' }}
                        >
                          Kembali Pilih Bulan
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </>
        </div>
      </div>

      {/* Paket Umrah End */}
    </div>
  );
}
